<template>
  <div class="order_component" v-if="accessCommande()">
    <div
      v-show="total_count != 0 || reserved_items_client.length>0"
      class="vx-bottom-bar"
      @click="checkScreen"
    >
      <div class="vx-bottom-bar-content">
        <div class="vx-bottom-bar-left">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
          <span>Voir ma commande</span>
          <span class="vx-bottom-badge">{{ total_count }}</span>
        </div>
        <span class="vx-bottom-price">{{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}</span>
      </div>
    </div>

    <modal name="order" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-close" @click="$modal.hide('order')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>

          <h2 class="vx-dark-title" style="text-align:center; margin-bottom:8px;">Ma Commande</h2>
          <p class="vx-dark-subtitle" style="text-align:center;">Que souhaitez-vous faire ?</p>

          <div style="width:100%; max-width:380px;">
            <div class="vx-action-row" @click="closeAllPopups">
              <span>Ajouter des articles</span>
              <div class="vx-arrow"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></div>
            </div>
            <div class="vx-action-row" @click="fideliteorpay()">
              <span>Payer ma commande</span>
              <div class="vx-arrow"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></div>
            </div>
            <div class="vx-action-row" @click="$modal.show('cart')">
              <span>Consulter ma commande</span>
              <div class="vx-arrow"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="cart" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body" style="padding:0;">

          <div class="vx-close" style="top:12px; left:12px; z-index:10;" @click="$modal.hide('cart')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>

          <div style="background:#fff; flex:1; display:flex; flex-direction:column; margin-top:50px; border-radius:24px 24px 0 0; overflow:hidden;">
            <div style="padding:24px 20px 12px;">
              <div class="vx-cart-header" style="margin-bottom:0;">
                <h3>Commande</h3>
                <span>{{ selectedTable ? `Table ${selectedTable} / ` : '' }}{{ total_count }} articles</span>
              </div>
            </div>

            <div style="flex:1; overflow-y:auto; padding:0 20px;">
              <swipe-list
                :items="reserved_items_client"
                transition-key="id"
                @swipeout:contentclick="contentClick"
                @swipeout:click="itemClick"
                @swipeout:doubleclick="itemDblClick"
              >
                <template slot-scope="{ item, index, revealLeft, revealRight, close }">
                  <div class="vx-cart-item">
                    <img
                      :src="images[item.title || item.name] ? `${apiPath1}/uploads/menus-items/${images[item.title || item.name]}` : `${apiPath1}/logos/logo.png`"
                      class="vx-cart-img"
                      alt=""
                      @error="$event.target.src=`${apiPath1}/logos/logo.png`"
                    />
                    <div class="vx-cart-info">
              
                      <span class="vx-cart-name">{{ item.title || item.name }}</span>
                      <div class="vx-cart-controls">
                        <div class="vx-qty-btn minus" v-if="item.objectNumber" @click="SubstractQuanity(item.index, item)"><span>-</span></div>
                        <div class="vx-qty-btn minus" v-else style="opacity:0.3;"><span>-</span></div>
                        <span class="vx-qty-val">{{ item.quantity }}</span>
                        <div class="vx-qty-btn plus" @click="AddQuanity(item.index)"><span>+</span></div>
                      </div>
                    </div>
                    <span class="vx-cart-price">{{ (item.unitPrice * item.quantity).toFixed(2) }} {{ currentCurrency.symbol }}</span>
                  </div>
                </template>
                <template slot="right" slot-scope="{ item }">
                  <div class="swipeout-action action-panel-left">
                    <div @click="RemoveItem(item.index)"><i class="fa fa-trash"></i></div>
                  </div>
                </template>
              </swipe-list>

              <div class="vx-empty" v-if="reserved_items_client.length == 0">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#a0b0ad" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><path d="M8 15s1.5-2 4-2 4 2 4 2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>
                <p style="color:#648080;">Votre panier est vide</p>
              </div>
            </div>

            <div v-if="reserved_items_client.length != reserved_items.length || showAll" style="text-align:center; padding:10px 0; border-top:1px solid #f0f3f2;">
              <span @click="showAllBill" style="color:#D4714E; font-size:13px; font-weight:600; cursor:pointer;">
                {{ !showAll ? 'Afficher toute la facture' : 'Afficher ma facture' }}
              </span>
            </div>

            <div style="padding:16px 20px 20px; border-top:1px solid #f0f3f2;">
              <div v-if="cart_button_text != 'Payer ma commande'">
                <div class="vx-btn primary vx-btn-price" @click="sendOrderDirect">
                  <span>{{ showAll ? 'Payer la facture' : cart_button_text }}</span>
                  <span>{{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}</span>
                </div>
              </div>
              <div v-else>
                <div v-if="!commandeInit" style="margin-bottom:10px;">
                  <div class="vx-btn secondary vx-btn-price" style="border-color:#D4714E;" @click="UpdateFact">
                    <span style="font-size:14px; color:#D4714E;">{{ isNewOrder && (!order || !order[0]) ? 'Commander' : order[0].menuItems.length != reserved_items.length ? 'Envoyer' : 'Fermer' }}</span>
                    <span style="font-size:14px; color:#D4714E;">{{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}</span>
                  </div>
                </div>
                <div v-if="(commandeInit && reserved_items_client.length) || showAll">
                  <div class="vx-btn primary vx-btn-price" @click="payOrLogin">
                    <span>{{ showAll ? 'Payer la commande' : cart_button_text }}</span>
                    <span>{{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </modal>

    <modal name="split" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body">
          <div class="vx-close" @click="$modal.hide('split')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>

          <div style="margin-top:40px;">
            <h2 class="vx-dark-title">Selectionner</h2>
            <p class="vx-dark-subtitle">vos articles a payer</p>
          </div>

          <div class="vx-scroll-area">
            <template v-for="item in reserved_items">
              <div
                :class="['vx-split-item', { selected: values.includes(item._id) }]"
                v-if="item.player_id == player_id || item.player_id == null || showAll"
                :key="`${item._id}_split`"
                @click="triggerValues(item._id)"
              >
                <img
                  :src="item.image ? `${apiPath1}/uploads/menus-items/${item.image}` : `${apiPath1}/logos/logo.png`"
                  class="vx-cart-img"
                  alt=""
                  @error="$event.target.src=`${apiPath1}/logos/logo.png`"
                />
                <div class="vx-cart-info">
                  <span class="vx-cart-name" style="color:#264740 !important;">{{ item.title ? item.title : item.name }}</span>
                  <span style="color:#648080; font-size:14px; font-weight:600;">{{ (item.unitPrice * item.quantity).toFixed(2) }} {{ currentCurrency.symbol }}</span>
                </div>
                <div class="vx-split-check" v-if="cart_button_text == 'Payer ma commande' && reserved_items.length > 1">
                  <svg v-if="values.includes(item._id)" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>
            </template>
          </div>

          <div class="vx-footer">
            <div v-if="reserved_items_client.length != reserved_items.length || showAll" style="text-align:center; margin-bottom:10px;">
              <span @click="showAllBill" style="color:#D4714E; font-size:13px; font-weight:600; cursor:pointer;">
                {{ !showAll ? 'Afficher toute la facture' : 'Afficher ma facture' }}
              </span>
            </div>
            <div class="vx-btn primary vx-btn-price" @click="payOrLogin">
              <span>{{ cart_button_text }}</span>
              <span>{{ total * 1 + pourboir * 1 }}{{ currentCurrency.symbol }}</span>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="client" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body">
          <div class="vx-close" @click="$modal.hide('client')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>

          <div class="client_form_conainer" style="margin-top:40px; width:100%;">
            <template v-if="!clientProg">
              <div class="google_fb" style="display:flex; justify-content:center; align-items:center; width:100%;">
                <div class="google_login">
                  <GoogleLogin :params="params1" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>
                </div>
                <div class="fb_login">
                  <v-facebook-login @sdk-init="handleSdkInit" @login="loginFacebook" v-model="facebook" app-id="1274685539667481"></v-facebook-login>
                </div>
              </div>
              <Login ref="loginForm" :CheckOrder="checkOrder" />
            </template>
            <template v-else>
              <div style="text-align:center; padding:30px 20px;">
                <div class="vx-avatar">
                  <span>{{ clientProg.nom[0] }}{{ clientProg.prenom[0] }}</span>
                </div>
                <h2 style="color:#fff; font-size:24px; font-weight:700; margin:16px 0 8px;">Bonjour {{ clientProg.nom }} {{ clientProg.prenom }}</h2>
                <p style="color:rgba(255,255,255,0.6); font-size:14px;">Vous avez <strong style="color:#D4714E;">{{ calculPoints() }}</strong> de credit</p>
              </div>
            </template>
          </div>

          <div class="vx-footer">
            <div class="vx-btn-row">
              <div class="vx-btn secondary" v-if="!clientProg" @click="$modal.show('signup')">
                <span>Sign up</span>
              </div>
              <div class="vx-btn primary" @click="saveClient()">
                <span>Suivant</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </modal>
    <modal name="signup" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body">
          <div class="vx-close" @click="$modal.hide('signup')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <div style="margin-top:40px; width:100%;">
            <Signup />
          </div>
        </div>
      </div>
    </modal>
    <modal name="fidelite" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body" style="padding-top:0;">
        <div class="vx-close" @click="$modal.hide('fidelite')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </div>
        <div class="profile_client_page">
          <div class="profile_header">
            <div class="profile_title">Prog</div>
            <div class="profile_title1">Fidélité</div>
            <div class="profile_circle"></div>
            <div class="profile_circle1"></div>
            <div class="profile_circle2"></div>
          </div>
          <div class="peofile_account" v-if="clientProg && cltprg">
            <div class="dot_profile_page"></div>
            <div class="dot_profile_page1"></div>
            <div class="profile_picture">
              <span>{{ clientProg.nom[0] }} {{ clientProg.prenom[0] }}</span>
            </div>
            <div class="profile_infos">
              <span class="profile_name"
                >{{ clientProg.nom }} {{ clientProg.prenom }}</span
              >
              <span class="profile_email">{{ clientProg.email }}</span>
            </div>
          </div>
          <div
            class="programme_details"
            v-if="cltprg && clientProg && programmeMenu[0]"
          >
            <div class="nom_programme">
              <h2>{{ programmeMenu[0].nom_programme }}</h2>
            </div>
            <div class="points_montant">
              <div class="profile_point1">
                <div class="dot_profile_page2"></div>
                <div class="dot_profile_page4"></div>
                <span>Points Fidélité</span>
                <i class="fa-solid fa-star fa-2x"></i>
                <span>{{ calculPoints() }} pts</span>
              </div>
              <div class="profile_point1">
                <span>Solde Fidélité</span>
                <i class="fa-solid fa-face-tongue-money fa-2x"></i>
                <span>{{ pointsTomontant() }} $</span>
              </div>
            </div>
            <!--<div class="earn_programme">
              <div class="label_e_program">
                <span>GAIN</span>
              </div>
              <div class="points_e_program">
                <span>{{ programmeMenu[0].earn.point }}pts</span>
                <span>{{ programmeMenu[0].earn.value }}$</span>
              </div>
            </div>
            <hr />
            <div class="earn_programme">
              <div class="label_e_program">
                <span>CONSOMMATION</span>
              </div>
              <div class="points_e_program">
                <span>{{ programmeMenu[0].burn.point }}pts</span>
                <span>{{ programmeMenu[0].burn.value }}$</span>
              </div>
            </div>-->
          </div>
          <!--<div class="profile_points" v-if="clientProg && cltprg">
            <div class="profile_point1">
              <div class="dot_profile_page2"></div>
              <div class="dot_profile_page4"></div>
              <span>Vos points Fidélité</span>
              <i class="fa-solid fa-star fa-2x"></i>
              <span>{{ calculPoints() }} / {{ pointsTomontant() }}</span>
            </div>
          </div>-->
          <div v-if="cltprg && clientProg" class="gain_earn">
            <span>Vous gagnerez <span class="orange_point"></span></span>
            <span> {{ calculEarn() }} pts</span>
          </div>
          <div class="gain_consom" v-if="clientProg">
            <div class="gain" @click="showProg = true">Consommer</div>
            <div
              class="gain"
              v-if="showProg === false"
              @click="$modal.show('payment')"
            >
              Gagner
            </div>
            <div
              class="gain"
              v-if="showProg === true"
              @click="$modal.show('payment')"
            >
              Suivant
            </div>
          </div>
          <p v-if="!clientProg" class="payment_text">
            Connectez vous pour pouvoir bénéficier du programme de fidélité
          </p>

          <div
            class="modal-footer bottom_commande_cart bottom_commande_login"
            v-if="!clientProg"
            style="background-color: #264740"
          >
            <!--<div id="client_save" @click="$modal.show('client')" class="modal_button">-->
            <div
              id="client_save"
              @click="$modal.show('login')"
              class="modal_button"
            >
              <div class="modal_button_text">Login</div>
            </div>
            <div
              id="client_save"
              @click="
                $modal.hide('fidelite');
                $modal.show('split');
              "
              class="modal_button"
            >
              <div class="modal_button_text">Suivant</div>
            </div>
          </div>

          <!--<div v-if="showProg" class="pourboire">
            <span>Burn</span>
            <input
              type="text"
              v-model="ptsburn"
              placeholder="Burn"
              class="pourboire_input"
            />
          </div>-->
          <div v-if="showProg" class="pourboire">
            <span>Combien voulez vous consommer de votre solde ?</span>
            <div
              style="
                display: flex;
                flex-direction: row;
                width: 100%;
                align-items: center;
                justify-content: center;
              "
            >
              <input
                type="text"
                v-model="valueconsom"
                placeholder="Burn"
                class="pourboire_input"
              />
              <p style="margin: 0 20px">$</p>
            </div>
          </div>
          <div v-if="showProg" class="order_infos">
            <div class="order_infos_line1">
              <span>Points à consommer</span>
              <span>{{ discountvalue() }} points</span>
            </div>
            <!--<div v-if="showProg" class="order_infos">
            <div class="order_infos_line1">
              <span>Points</span>
              <span>{{ ptsburn }} points</span>
            </div>
            <div class="order_infos_line">
              <span>Burn<span class="orange_point"></span></span>
              <span>{{ burndiscount() }} {{ currentCurrency.symbol }}</span>
            </div>-->

            <div v-if="discount < total && dscnt" class="order_infos_line">
              <span>montant à payer<span class="orange_point"></span></span>
              <span>{{ discount }} {{ currentCurrency.symbol }}</span>
            </div>
          </div>
          <div v-if="!dscnt && clientProg" class="order_infos_line">
            <span>Total<span class="orange_point"></span></span>
            <span> {{ total }} {{ currentCurrency.symbol }}</span>
          </div>
        </div>
        </div>
      </div>
    </modal>
    <modal name="payment" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body" style="padding-top:0;">
        <div class="vx-close" @click="$modal.hide('payment')">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </div>

        <div style="width:100%; margin-top:40px;">
          <h2 class="vx-dark-title">Mode de paiement</h2>
          <p class="vx-dark-subtitle">
            Veuillez sélectionner votre mode de paiement préféré
          </p>

          <!-- <div class="payment_modes">
            <div @click="active_payment=0" :class="`payment_mode ${active_payment==0?'active':''}`">
              <span>Espece</span>
              <img src="htttp://localhost:3333/new_images/payment/cash.png" alt="" srcset="">
            </div>
            <div @click="active_payment=1" :class="`payment_mode ${active_payment==1?'active':''}`">
              <span>Carte </span>
              <img src="htttp://localhost:3333/new_images/payment/card.png" alt="" srcset="">
            </div>

            <div @click="()=>{active_payment=2;moneticoPayment()}" :class="`payment_mode ${active_payment==2?'active':''}  origin`">
              <span>Monetico</span>
              <img src="htttp://localhost:3333/new_images/payment/monetico.png" alt="" srcset="">
            </div>

            <div @click="active_payment=3" :class="`payment_mode ${active_payment==3?'active':''}`">
              <span>Bitcoin</span>
              <img src="htttp://localhost:3333/new_images/payment/bitcoin.png" alt="" srcset="">
            </div>

            <div @click="active_payment=4" :class="`payment_mode ${active_payment==4?'active':''}`">
              <span>Paypal</span>
              <img src="htttp://localhost:3333/new_images/payment/paypal.png" alt="" srcset="">
            </div>

            <div @click="active_payment=5" :class="`payment_mode ${active_payment==5?'active':''}`">
              <span>Google pay</span>
              <img src="htttp://localhost:3333/new_images/payment/google.png" alt="" srcset="">
            </div>

            <div @click="active_payment=6" :class="`payment_mode ${active_payment==6?'active':''}`">
              <span>Apple pay</span>
              <img src="htttp://localhost:3333/new_images/payment/apple.png" alt="" srcset="">
            </div>

          </div> -->
          <div class="payement_buttons_container">
            <div class="payement_buttons">
              <div
                @click="paiment_mode = 1"
                :class="`payment_button ${paiment_mode == 1 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/card.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                @click="paiment_mode = 2"
                :class="`payment_button ${paiment_mode == 2 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/apple.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                @click="paiment_mode = 3"
                :class="`payment_button ${paiment_mode == 3 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/google.png"
                  alt=""
                  srcset=""
                />
              </div>
              <div
                @click="paiment_mode = 4"
                :class="`payment_button ${paiment_mode == 4 ? 'active' : ''}`"
              >
                <img
                  src="htttp://localhost:3333/new_images/payment/paypal.png"
                  alt=""
                  srcset=""
                />
              </div>
              <!-- <div @click="paiment_mode=5" :class="`payment_button  ${paiment_mode==5?'active':''}`">
            <img src="htttp://localhost:3333/new_images/payment/clicandpay.png" class="clicandpay" alt="" srcset="">
          </div> -->

              <!-- <div class="paymement_button cash" @click="sendOrder(1)">
              
              <span>Espèce</span>
              <img src="htttp://localhost:3333/new_images/payment/cash.png" alt="" srcset="">
            </div>
           
            <div
              class="paymement_button card_monetico"
              @click="moneticoPayment()"
            >
              <span>Monetico</span>
              
              <img src="htttp://localhost:3333/new_images/payment/monetico.png" alt="" srcset="">
            </div>
            <div class="paymement_button bitcoin_card">
             
              <span>Bitcoin</span>
              <img src="htttp://localhost:3333/new_images/payment/bitcoin.png" alt="" srcset="">
            </div>
            <div class="paymement_button " @click="moneticoPayment()">
              <span>Carte bancaire</span>
              
              <img src="htttp://localhost:3333/new_images/payment/card.png" alt="" srcset="">
            </div>
            <div class="paymement_button " @click="initStripe()">
              <span>Stripe</span>
              
              <img src="htttp://localhost:3333/new_images/payment/card.png" alt="" srcset="">
            </div>
            <div class="paymement_button google_pay">
              <GooglePayButton
                id="google-pay-btn"
                :options="options"
                @payed="processPayment($event)"
                @cancel="handleCancel"
              />
            </div>
            
            <form id="payment-form" v-show="showStripe">
              <div id="card-element">
              </div>
              <button id="submit">
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">Pay now</span>
              </button>
              <p id="card-error" role="alert"></p>
              <p class="result-message hidden">
                Payment succeeded, see the result in your
                <a href="" target="_blank">Stripe dashboard.</a> Refresh the
                page to pay again.
              </p>
            </form>
            <div class="paymement_button card paypal_button">
              <img
                src="htttp://localhost:3333/paypal.svg"
                alt=""
                class="paypal_payment_icon"
              />
              <PayPal
                :amount="total"
                :currency="currentCurrency.currency_code"
                :client="paypal"
                :button-style="aStyle"
                env="sandbox"
                @payment-authorized="authorized"
                @payment-completed="completed"
                @payment-cancelled="cancelled"
              >
              </PayPal>
            </div> -->
            </div>
          </div>
          <div class="payment_content">
            <div v-if="isRoomCharge" class="transfert_block">
              <p v-if="paiment_mode == 1">Payer par transfert chambre</p>
              <div @click="transfertChmabre()" class="payment_content_button">
                <span>Transfert chambre </span>
                <div class="arrow_right">
                  <span>></span>
                </div>
              </div>
            </div>
            <p v-if="paiment_mode == 1">Payer par carte</p>
            <!-- <div
              v-if="paiment_mode == 1 && modes.monetico"
              @click="moneticoPayment()"
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>

            <div
              @click="
                () => {
                  sendOrder(3);
                }
              "
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>
            <div
              v-if="paiment_mode == 1 && modes.stripe"
              @click="initStripe()"
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>-->

            <div
              v-if="paiment_mode == 1"
              @click="moneticoC3()"
              class="payment_content_button"
            >
              <span>Payer par carte </span>
              <div class="arrow_right">
                <span>></span>
              </div>
            </div>

            <form
              id="payment-form"
              v-show="paiment_mode == 1 && modes.stripe && showStripe"
            >
              <div id="card-element"></div>
              <button id="submit">
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">Pay now</span>
              </button>
              <p id="card-error" role="alert"></p>
              <p class="result-message hidden">
                Payment succeeded, see the result in your
                <a href="" target="_blank">Stripe dashboard.</a> Refresh the
                page to pay again.
              </p>
            </form>

            <p v-if="paiment_mode == 2">Payer par Apple Pay</p>
            <!-- <div v-if="paiment_mode==2" class="payment_content_button">
              <span>Payer par Apple Pay </span>
              <img src="htttp://localhost:3333/new_images/payment/apple.png" alt="" srcset="">
            </div> -->
            <template v-if="paiment_mode == 2">
              <apple-pay-button
                @click="applePay"
                buttonstyle="black"
                type="plain"
                locale="en"
              ></apple-pay-button>
            </template>
            <p v-if="paiment_mode == 3">Payer par Google Pay</p>
            <!-- <div v-if="paiment_mode==3" class="payment_content_button">
              <span>Payer par Google Pay </span>
              <img src="htttp://localhost:3333/new_images/payment/google.png" alt="" srcset="">
            </div> -->
            <template v-if="paiment_mode == 3">
              <GooglePayButton
                id="google-pay-btn"
                :options="options"
                @payed="processPayment($event)"
                @cancel="handleCancel"
              />
            </template>

            <p v-if="paiment_mode == 4">Payer par Paypal</p>

            <!-- <div v-if="paiment_mode==4" @click="initClicAndPay" class="payment_content_button">
              <span>Payer par Paypal </span>
              <img src="htttp://localhost:3333/new_images/payment/paypal.png" alt="" srcset="">
              
            </div>  -->

            <template v-if="paiment_mode == 4">
              <PayPal
                :amount="total"
                :currency="currentCurrency.currency_code"
                :client="paypal"
                :button-style="aStyle"
                env="sandbox"
                @payment-authorized="authorized"
                @payment-completed="completed"
                @payment-cancelled="cancelled"
                :braintree="braintreeSdk"
              ></PayPal>
            </template>

            <div
              v-if="paiment_mode == 1 && modes.clicandpay"
              @click="initClicAndPay"
              class="payment_content_button"
            >
              <span>Payer par Click&Pay </span>
              <img
                src="htttp://localhost:3333/new_images/payment/clicandpay.png"
                class="clicandpay"
                alt=""
                srcset=""
              />
            </div>

            <div
              v-if="clicToken"
              class="kr-embedded"
              kr-popin
              :kr-form-token="clicToken"
            >
              <!-- payment form fields -->
              <div class="kr-pan"></div>
              <div class="kr-expiry"></div>
              <div class="kr-security-code"></div>

              <!-- payment form submit button -->
              <button class="kr-payment-button"></button>

              <!-- error zone -->
              <div class="kr-form-error"></div>
            </div>
            <!-- <div :class="`kr_payment ${paiment_mode==5?'visible':''}`">
              <div   class="kr-embedded" 
                kr-form-token="DEMO-TOKEN-TO-BE-REPLACED">

                  <div class="kr-pan"></div>
                  <div class="kr-expiry"></div>
                  <div class="kr-security-code"></div>

                  <button class="kr-payment-button"></button>

                  <div class="kr-form-error"></div>
              </div>
            </div> -->

            <!-- <div class="confirm_send">
              <span>M'envoyer une facture par email</span>
            </div> -->
            <div class="pourboirs">
              <div
                :class="`pourboir_btn ${
                  pourboir == 1 && !showOther ? 'active' : ''
                } `"
                @click="setPourboir(1)"
              >
                1{{ currentCurrency.symbol }}
              </div>
              <div
                :class="`pourboir_btn ${
                  pourboir == 2 && !showOther ? 'active' : ''
                } `"
                @click="setPourboir(2)"
              >
                2{{ currentCurrency.symbol }}
              </div>
              <div
                :class="`pourboir_btn ${
                  pourboir == 3 && !showOther ? 'active' : ''
                } `"
                @click="setPourboir(3)"
              >
                3{{ currentCurrency.symbol }}
              </div>
              <div
                :class="`pourboir_btn ${
                  showOther && !showProg ? 'active' : ''
                } `"
                @click="(showOther = true), (showProg = false)"
              >
                Autre
              </div>
              <!-- <div
                v-if="cltprg && clientProg && programmeMenu[0]"
                :class="`pourboir_btn ${
                  showProg && !showOther ? 'active' : ''
                } `"
                @click="(showProg = true), (showOther = false)"
              >
                {{ programmeMenu[0].nom_programme }}
              </div>-->
            </div>
            <!--<div class="pourboire" v-if="showProg">
              <span>Burn</span>
              <input
                type="text"
                v-model="ptsburn"
                placeholder="Burn"
                class="pourboire_input"
              />
            </div> -->
            <div class="pourboire" v-if="showOther">
              <span>Pourboire</span>
              <input
                type="text"
                v-model="pourboir"
                placeholder="Pourboire"
                class="pourboire_input"
              />
            </div>

            <div class="order_infos">
              <!--
              <div v-if="showOther" class="order_infos_line1">
                <span>Pourboire</span>
                <span>{{ pourboir }} {{ currentCurrency.symbol }}</span>
              </div>-->

              <!-- <div v-if="showProg" class="order_infos_line1">
                <span>Points</span>
                <span>{{ ptsburn }} points</span>
              </div>-->

              <!--<div v-if="showOther" class="order_infos_line">
                <span>Total<span class="orange_point"></span></span>
                <span>{{ total * 1 + pourboir * 1
                }}{{ currentCurrency.symbol }}</span>
              </div>-->

              <!--<div v-if="showProg" class="order_infos_line">
                <span>Burn<span class="orange_point"></span></span>
                <span>{{ burndiscount() }} {{ currentCurrency.symbol }}</span>
              </div>
              <div v-if="showProg" class="order_infos_line">
                <span>Earn<span class="orange_point"></span></span>
                <span>{{ calculEarn() }} pts</span>
              </div>-->
            </div>
            <div
              v-if="client_reservation && client_reservation.total * 1 > 0"
              class="order_infos_line"
            >
              <span>Prépayé<span class="orange_point"></span></span>
              <span
                >{{ (client_reservation.total * 1).toFixed(2) }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
            <div class="order_infos_line">
              <span>Total<span class="orange_point"></span></span>
              <span>
                {{ toFixed(total * 1 + total_check_discount * 1) }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
            <div v-if="pourboir > 0" class="order_infos_line1">
              <span>Pourboire</span>
              <span>{{ pourboir }} {{ currentCurrency.symbol }}</span>
            </div>
            <div v-if="dscnt" class="order_infos_line">
              <span>Discount<span class="orange_point"></span></span>
              <span> - {{ valueconsom }} {{ currentCurrency.symbol }}</span>
            </div>

            <div v-if="total_check_discount != 0" class="order_infos_line">
              <span>Discount<span class="orange_point"></span></span>
              <span>
                - {{ total_check_discount }} {{ currentCurrency.symbol }}</span
              >
            </div>
            <div v-if="dscnt" class="order_infos_line">
              <span>Montant final<span class="orange_point"></span></span>
              <span>
                {{
                  (
                    discount -
                    (client_reservation && client_reservation.total * 1 > 0
                      ? client_reservation.total * 1
                      : 0)
                  ).toFixed(2)
                }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
            <div v-else class="order_infos_line">
              <span>Montant final<span class="orange_point"></span></span>
              <span>
                {{
                  (
                    total -
                    (client_reservation && client_reservation.total * 1 > 0
                      ? client_reservation.total * 1
                      : 0) +
                    (pourboir > 0 ? pourboir * 1 : 0)
                  ).toFixed(2)
                }}
                {{ currentCurrency.symbol }}</span
              >
            </div>
          </div>
          <div class="loader">
            <div class="loader_container">
              <div class="lds-ripple">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>

          <div class="payment_container">
            <form
              method="post"
              id="payment_form"
              ref="payment_form"
              action="https://p.monetico-services.com/test/paiement.cgi"
            >
              <input
                type="hidden"
                id="TPE"
                name="TPE"
                :value="
                  restaurant && restaurant.configurationPaiment
                    ? restaurant.configurationPaiment.tpe
                    : ''
                "
              />
              <input
                type="hidden"
                id="societe"
                name="societe"
                :value="
                  restaurant && restaurant.configurationPaiment
                    ? restaurant.configurationPaiment.societe
                    : ''
                "
              />
              <input type="hidden" id="lgue" name="lgue" value="FR" />
              <input type="hidden" id="version" name="version" value="3.0" />
              <input
                type="hidden"
                id="reference"
                name="reference"
                :value="config.ref"
              />
              <input type="hidden" id="date" name="date" :value="config.date" />
              <input
                type="hidden"
                id="montant"
                name="montant"
                :value="config.price"
              />
              <input
                type="hidden"
                id="contexte_commande"
                name="contexte_commande"
                :value="config.context"
              />
              <input
                type="hidden"
                id="libre"
                name="texte-libre"
                :value="config.desc"
              />
              <input type="hidden" id="MAC" name="MAC" :value="config.MAC" />
              <input
                type="hidden"
                id="url_retour_ok"
                name="url_retour_ok"
                :value="config.url_retour_ok"
              />
              <input
                type="hidden"
                id="url_retour_err"
                name="url_retour_err"
                :value="config.url_retour_err"
              />
            </form>
          </div>
        </div>
        </div>
      </div>
    </modal>

    <modal name="signature" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card" style="text-align:left;">
            <h2 class="vx-title" style="text-align:center;">Transfert chambre</h2>
            <p class="vx-subtitle" style="text-align:center;">Signez pour confirmer le transfert</p>
            <div style="background:#F8FAF9; border-radius:12px; padding:8px; margin-bottom:16px;">
              <canvas id="canva" style="width:100%; height:150px; border-radius:8px;"></canvas>
            </div>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="SaveSignature"><span>Confirmer</span></div>
        </div>
      </div>
    </modal>

    <modal name="transfert" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card" v-if="operaReservation">
            <div class="vx-icon-circle orange">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
            </div>
            <h2 class="vx-title">Transfert chambre</h2>
            <p class="vx-subtitle">
              Bonjour Mr. {{ operaReservation.reservationGuests[0].profileInfo.profile.customer.personName[0].givenName }}
              {{ operaReservation.reservationGuests[0].profileInfo.profile.customer.personName[0].surname }}
            </p>
            <div style="background:#F8FAF9; border-radius:12px; padding:14px; text-align:left; margin-bottom:16px;">
              <p style="margin:0 0 4px; font-size:13px; color:#648080;">Type: <strong style="color:#264740;">{{ operaReservation.roomStay.currentRoomInfo.roomType }}</strong></p>
              <p style="margin:0; font-size:13px; color:#648080;">Chambre: <strong style="color:#264740;">{{ operaReservation.roomStay.currentRoomInfo.roomId }}</strong></p>
            </div>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="OpenSignature"><span>Confirmer</span></div>
        </div>
      </div>
    </modal>

    <modal name="reservation_code" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle orange">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <h2 class="vx-title">Code reservation</h2>
            <p class="vx-subtitle">Entrez le code reservation recu par e-mail</p>
            <input class="vx-input on-card" type="number" v-model="operaRef" placeholder="Code reservation" />
            <p v-if="showOperaError" style="color:#ef5350; font-size:13px; margin-top:8px;">Code invalide</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="OpenTransfert"><span>Confirmer</span></div>
        </div>
      </div>
    </modal>

    <modal name="pin" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle orange">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
            </div>
            <h2 class="vx-title">Table reservee</h2>
            <p class="vx-subtitle">Entrez le code PIN recu par e-mail pour acceder a cette table</p>
            <input class="vx-input on-card" type="number" max="4" v-model="pin" placeholder="Code PIN" />
            <p v-if="showPinError" style="color:#ef5350; font-size:13px; margin-top:8px;">Code PIN invalide</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="ConfirmePin"><span>Confirmer</span></div>
        </div>
      </div>
    </modal>

    <modal name="rating" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle orange">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
              </svg>
            </div>
            <h2 class="vx-title">Votre avis</h2>

            <p style="font-size:14px; color:#264740; font-weight:600; margin:16px 0 8px;">Ambiance du restaurant</p>
            <div class="vx-stars">
              <svg v-for="s in 5" :key="'amb'+s" @click="ambiancerating = s" class="vx-star" viewBox="0 0 24 24" :fill="ambiancerating >= s ? '#D4714E' : 'none'" :stroke="ambiancerating >= s ? '#D4714E' : '#dce5e3'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            </div>

            <p style="font-size:14px; color:#264740; font-weight:600; margin:16px 0 8px;">Qualite du service</p>
            <div class="vx-stars">
              <svg v-for="s in 5" :key="'srv'+s" @click="servicerating = s" class="vx-star" viewBox="0 0 24 24" :fill="servicerating >= s ? '#D4714E' : 'none'" :stroke="servicerating >= s ? '#D4714E' : '#dce5e3'" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            </div>

            <p class="vx-label" style="margin-top:16px;">Scannez de nouveau le QR Code pour passer au paiement.</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="passRating"><span>Fermer</span></div>
        </div>
      </div>
    </modal>

    <modal name="success" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle green">
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4CAF50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h2 class="vx-title">Paiement effectue !</h2>
            <p class="vx-subtitle">Merci pour votre commande. Nous esperons vous revoir bientot !</p>
            <p class="vx-label" style="margin-bottom:20px;">Pour consulter votre facture, rendez-vous sur notre application ou sur votre boite mail.</p>
            <div class="vx-btn-row" style="margin-bottom:0;">
              <div class="vx-btn outline" @click="startDownload" style="font-size:13px;padding:12px 0;"><span style="color:#D4714E;font-size:13px;">Telecharger</span></div>
              <div class="vx-btn outline" @click="sendEmail" style="font-size:13px;padding:12px 0;"><span style="color:#D4714E;font-size:13px;">Envoyer par email</span></div>
            </div>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="closeAll()"><span>Fermer</span></div>
        </div>
      </div>
    </modal>

    <modal name="error" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-close" @click="$modal.hide('error')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <div class="vx-card">
            <div class="vx-icon-circle red">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ef5350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="15" y1="9" x2="9" y2="15"/><line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
              <div class="vx-badge red">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
            <h2 class="vx-title">Erreur</h2>
            <p class="vx-subtitle" v-if="error_message.includes('Desole,')" v-html="error_message"></p>
            <p class="vx-subtitle" v-else>Un probleme est survenu avec votre commande. Merci de reessayer plus tard.</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="$modal.hide('error')"><span>Retour</span></div>
        </div>
      </div>
    </modal>

    <modal name="error_payment" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-close" @click="$modal.hide('error_payment')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <div class="vx-card">
            <div class="vx-icon-circle red">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ef5350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/>
              </svg>
              <div class="vx-badge red">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </div>
            </div>
            <h2 class="vx-title">Paiement echoue</h2>
            <p class="vx-subtitle">Votre paiement n'est pas termine. Veuillez reessayer.</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="$modal.hide('error_payment')"><span>Retour</span></div>
        </div>
      </div>
    </modal>

    <modal name="prepaiment" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-close" @click="$modal.hide('prepaiment')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <div class="vx-card" style="text-align:left;">
            <h2 class="vx-title" style="text-align:center; margin-bottom:20px;">Options de paiement</h2>

            <p style="font-size:14px; color:#264740; font-weight:600; margin-bottom:12px;">Selectionner vos articles a payer ?</p>
            <div class="vx-btn-row" style="margin-bottom:20px;">
              <div :class="['vx-btn', !showAll ? 'primary' : 'outline']" @click="showAll = false" style="padding:10px 0;"><span :style="!showAll ? 'color:#fff' : 'color:#D4714E'" style="font-size:14px;">Oui</span></div>
              <div :class="['vx-btn', showAll ? 'primary' : 'outline']" @click="showAll = true" style="padding:10px 0;"><span :style="showAll ? 'color:#fff' : 'color:#D4714E'" style="font-size:14px;">Non</span></div>
            </div>

            <p style="font-size:14px; color:#264740; font-weight:600; margin-bottom:12px;">Diviser la note en {{ covers }} parts egales ?</p>
            <div class="vx-btn-row" style="margin-bottom:0;">
              <div :class="['vx-btn', splitEqual ? 'primary' : 'outline']" @click="splitEqual = true" style="padding:10px 0;"><span :style="splitEqual ? 'color:#fff' : 'color:#D4714E'" style="font-size:14px;">Oui</span></div>
              <div :class="['vx-btn', !splitEqual ? 'primary' : 'outline']" @click="splitEqual = false" style="padding:10px 0;"><span :style="!splitEqual ? 'color:#fff' : 'color:#D4714E'" style="font-size:14px;">Non</span></div>
            </div>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="$modal.hide('prepaiment')"><span>Confirmer</span></div>
        </div>
      </div>
    </modal>
    <modal name="pending" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-close" @click="$modal.hide('pending')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <div class="vx-card">
            <div class="vx-icon-circle orange">
              <div class="vx-icon-ring"></div>
              <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 13.87A4 4 0 0 1 7.41 6a5.11 5.11 0 0 1 1.05-1.54 5 5 0 0 1 7.08 0A5.11 5.11 0 0 1 16.59 6 4 4 0 0 1 18 13.87V21H6z"/><line x1="6" y1="17" x2="18" y2="17"/>
              </svg>
              <div class="vx-badge green">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </div>
            </div>
            <h2 class="vx-title">Commande envoyee !</h2>
            <p class="vx-subtitle">Votre commande a bien ete recue et est en cours de preparation par notre chef.</p>
            <div class="vx-steps">
              <div class="vx-step done"><div class="vx-step-dot"></div><span>Recue</span></div>
              <div class="vx-step-line done"></div>
              <div class="vx-step active"><div class="vx-step-dot"></div><span>Preparation</span></div>
              <div class="vx-step-line"></div>
              <div class="vx-step"><div class="vx-step-dot"></div><span>Service</span></div>
            </div>
            <p class="vx-label">Veuillez patienter, votre commande arrive bientot.</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn primary" @click="refreshAll"><span>Fermer</span></div>
        </div>
      </div>
    </modal>

    <modal name="loading" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle orange">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#D4714E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <h2 class="vx-title">Operation en cours</h2>
            <p class="vx-subtitle">Veuillez patienter, votre operation sera bientot terminee !</p>
            <div class="vx-loader">
              <div class="vx-loader-dot"></div>
              <div class="vx-loader-dot"></div>
              <div class="vx-loader-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="splash">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <img :src="`${apiPath1}/logos/${restaurant.logo}`" alt="" style="width:80px; height:80px; border-radius:50%; object-fit:cover; margin:0 auto 16px; display:block;" @error="$event.target.style.display='none'" />
            <h2 class="vx-title">{{ restaurant.name }}</h2>
            <p class="vx-subtitle">Veuillez patienter !</p>
            <div class="vx-loader">
              <div class="vx-loader-dot"></div>
              <div class="vx-loader-dot"></div>
              <div class="vx-loader-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="expire" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-close" @click="$modal.hide('expire')">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </div>
          <div class="vx-card">
            <div class="vx-icon-circle red">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ef5350" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <h2 class="vx-title">Session expiree</h2>
            <p class="vx-subtitle">Votre session a expire, veuillez rescanner le QR code.</p>
          </div>
        </div>
      </div>
    </modal>

    <modal name="askJoin" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
              </svg>
            </div>
            <h2 class="vx-title">Table occupee</h2>
            <p class="vx-subtitle">Quelqu'un utilise deja cette table. Souhaitez-vous rejoindre sa table ?</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn-row">
            <div class="vx-btn secondary" @click="$modal.hide('askJoin')"><span>Non</span></div>
            <div class="vx-btn primary" @click="sendRequest"><span>Oui</span></div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="askJoinName" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
              </svg>
            </div>
            <h2 class="vx-title">Quel est votre nom ?</h2>
            <p class="vx-subtitle">Entrez votre nom pour rejoindre la table</p>
            <input class="vx-input on-card" placeholder="Votre nom" v-model="clientName" />
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn-row">
            <div class="vx-btn secondary" @click="$modal.hide('askJoinName')"><span>Annuler</span></div>
            <div class="vx-btn primary" @click="sendClientName"><span>Confirmer</span></div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="AcceptJoinRequest" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/><polyline points="17 11 19 13 23 9"/>
              </svg>
            </div>
            <h2 class="vx-title">Demande de connexion</h2>
            <p class="vx-subtitle">{{ requestJoin.nom }} souhaite rejoindre votre table. Accepter ?</p>
          </div>
          <div class="vx-gap-md"></div>
          <div class="vx-btn-row">
            <div class="vx-btn secondary" @click="$modal.hide('AcceptJoinRequest')"><span>Annuler</span></div>
            <div class="vx-btn primary" @click="acceptJoin"><span>Confirmer</span></div>
          </div>
        </div>
      </div>
    </modal>

    <modal name="askJoinWating" @opened="onOpened" @closed="onClosed">
      <div class="vx-modal">
        <div class="vx-modal-bg"></div>
        <div class="vx-modal-body centered">
          <div class="vx-card">
            <div class="vx-icon-circle blue">
              <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#1976D2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
              </svg>
            </div>
            <h2 class="vx-title">Veuillez patienter</h2>
            <p class="vx-subtitle">Nous demandons une connexion a la table...</p>
            <div class="vx-loader">
              <div class="vx-loader-dot"></div>
              <div class="vx-loader-dot"></div>
              <div class="vx-loader-dot"></div>
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- <div id="audio">
      <audio
        id="my_audio"
        src="https://freesound.org/data/previews/159/159583_2869798-lq.mp3"
      ></audio>
      <audio
        id="beep__hover"
        src="http://freesound.org/data/previews/263/263133_2064400-lq.mp3"
      ></audio>
    </div> -->
  </div>
</template>

<script>
var context = new AudioContext(); // Make it crossbrowser
import Login from "../progfidelite/Login.vue";
import Signup from "../progfidelite/Signup.vue";
import Orangedot from "../designs/Orangedot.vue";
import Bienvenue from "../designs/Bienvenue.vue";

// import ClientProfile from '../progfidelite/Compte_salon.vue'
// import HistoriqueProfile from '../progfidelite/Historique_salon.vue'
// import RestoInfo from '../wegets/options.vue'
import Navmenu from "../progfidelite/Navmenu.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import PayPal from "vue-paypal-checkout";
const topicName = "chat";
import Axios from "axios";
import { SwipeList, SwipeOut } from "vue-swipe-actions";
import "vue-swipe-actions/dist/vue-swipe-actions.css";
import "./style.css";
import GoogleLogin from "vue-google-login";
import VFacebookLogin from "vue-facebook-login-component";
import GooglePayButton from "vue-google-pay";
import moment from "moment";
import axios from "axios";
import { apiPath1 } from "../../constants/config";
export default {
  components: {
    // ClientProfile,
    // HistoriqueProfile,
    // RestoInfo,
    Navmenu,
    Login,
    Signup,
    Orangedot,
    Bienvenue,
    PayPal,
    SwipeOut,
    SwipeList,
    GoogleLogin,
    VFacebookLogin,
    GooglePayButton: GooglePayButton,
  },
  props: [
    "is_commande",
    "reserved_items",
    "currentCurrency",
    "SubstractQuanity",
    "AddQuanity",
    "RemoveItem",
    "restaurant",
    "hasModule",
    "hasCommande",
    "listSections"
  ],
  data() {
    return {
      apiPath1,
      pendingPayment: false,
      total_check_discount: 0,
      pourboir: 0,
      old_order1: {},
      requestJoin: {},
      clientName: "",
      commandeInit: true,
      image: "",
      signaturePad: null,
      operaReservation: null,
      showPinError: false,
      pin: "",
      showOperaError: false,
      operaRef: "722760",

      res_to_download: null,
      pourboir: 0,

      ptsburn: 0,
      progburn: 0,
      discount: 0,
      dscnt: false,
      ptsg: 0,
      valueconsom: 0,
      montant_client: 0,
      points_client: 0,

      ambiancerating: 0,
      servicerating: 0,

      showOther: false,
      showProg: false,

      paiment_mode: 1,
      reference_payment: null,
      active_payment: 0,
      splitEqual: false,
      stars: 0,
      covers: 1,
      options: {
        environment: "TEST",
        buttonColor: "white",
        allowedCardNetworks: [
          "AMEX",
          "DISCOVER",
          "INTERAC",
          "JCB",
          "MASTERCARD",
          "VISA",
        ],
        allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        merchantInfo: {
          merchantName: "Ihospitality",
          // merchantName: this.restaurant.googlepay.merchantName ? this.restaurant.googlepay.merchantName : "Ihospitality",
          // merchantName: this.restaurant.googlepay.merchantName,
          // merchantId: this.restaurant.googlepay.merchantId,
          // merchantId: this.restaurant.googlepay.merchantId ? this.restaurant.googlepay.merchantId : "BCR2DN4TZCGNJMLG",
          merchantId: "BCR2DN4TZCGNJMLG",
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: "1.00",
          currencyCode: "EURO",
          countryCode: "FR",
        },
      },
      FB: {},
      facebook: {},
      params1: {
        client_id:
          "592182686828-tu4qq08ir4h83bo67hpo105um1fhhp77.apps.googleusercontent.com",
      },
      // only needed if you want to render the button with the google ui
      renderParams: {
        width: 250,
        height: 50,
        longtitle: true,
      },
      values: [],
      showAll: false,
      showStripe: false,
      cart_button_text: "Commander",
      stripe: {},
      client_form: {},
      config: {
        MAC: "",
        url_retour_ok: "",
        url_retour_err: "",
        price: "",
        currentDate: "",
        context: "",
        desc: "",
        ref: "",
      },
      data: [11, 2, 3, 4, 5],
      restau: {
        configurationPaiment: {},
      },
      aStyle: {
        label: "checkout",
        size: "large",
        color: "gold",
        // shape: 'rect',
        // color: 'black',
      },
      params: {},
      paypal_paiement: null,
      braintreeSdk: window.braintre,

      clicToken: null,
    };
  },
  watch: {
    leader(newVal, oldVal) {
      if (newVal && (!oldVal || !oldVal.leader)) {
        // alert(`${newVal.leader}!=${this.client._id} `)
        // if(newVal ){

        if (newVal.leader != this.client._id) {
          if (!newVal.participants.includes(this.client._id)) {
            this.$modal.show("askJoin");
          }
        }
      }
    },
    menus(newVal) {},
    client_reservation(newVal) {
      if (newVal) {
        if (newVal.status == "confirmed") {
          this.$modal.show("pin");
        }
      }
    },
    order(newVal) {
      console.log({newVal,"test":"test"})
      if (newVal && newVal.ref) {
        this.reference_payment = newVal.ref;
      }
    },
    client: function (newval) {
      this.client_form = Object.assign({}, { ...newval });

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];

        pas = 2;
      }

      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      setTimeout(() => {
        this.CheckLeader({
          table,
          restaurant: restaurant_,
          menu: menu_,
          user_id: this.client._id,
        });
      }, 200);
    },
    isloadingOrder: function (newval) {
      if (newval) {
        this.$modal.show("loading");
      } else {
        this.$modal.hide("loading");
      }
    },
    payement_config: function (newVal) {
      if (newVal) {
        console.log(
          "payement_configpayement_configpayement_configpayement_config"
        );
        console.log(newVal);
        this.config = Object.assign({}, { ...newVal });
        setTimeout(() => {
          this.$refs.payment_form.submit();
        }, 500);
      }
    },
    reserved_items(newVal, oldVal) {
      let values = [];
      newVal.map((item) => {
        if (item.player_id !== undefined) {
          if (item.player_id == this.player_id) {
            values.push(item._id);
          }
        } else {
          if (item._id) values.push(item._id);
          else values.push(item.menuItemId);
        }
      });

      this.values = values;
    },
    // order(newVal,oldVal){
    //   if(!newVal){
    //     return;
    //   }
    //   this.cart_button_text  = "Payer ma commande"
    //   setTimeout(()=>{
    //     // this.$modal.show("split");

    //     if(!oldVal || !oldVal._id){
    //        this.$modal.show("cart");
    //     }

    //   },100)
    // }
    reserved_items_client(newVal, oldVal) {
      if (newVal.length > 0 && oldVal.length == 0 && this.order._id) {
        this.cart_button_text = "Payer ma commande";
        let exist = newVal.find((itm) => !itm._id);

        setTimeout(() => {
          if (!exist) {
            if (!window.location.href.includes("success=true")) {
              this.$modal.show("order");
            }
          }

          this.commandeInit = true;
          // this.$modal.show("split");
          // this.$modal.show("prepaiment");
          // this.$modal.show("cart");
        }, 10);
      }
    },
    total(newVal) {
      this.commandeInit = false;
      this.options = {
        // environment: 'PRODUCTION',
        environment: "TEST",
        buttonColor: "white",
        allowedCardNetworks: [
          "AMEX",
          "DISCOVER",
          "INTERAC",
          "JCB",
          "MASTERCARD",
          "VISA",
        ],
        allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        merchantInfo: {
          // merchantName: this.restaurant.googlepay.merchantName,
          // merchantId: this.restaurant.googlepay.merchantId,
          merchantName: "Ihospitality",
          merchantId: "BCR2DN4TZCGNJMLG",
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: `${parseFloat(newVal + this.pourboir).toFixed(2)}`,
          currencyCode: this.currentCurrency.currency_code,
          countryCode: "FR",
        },
      };
    },
    pourboir(newVal, oldVal) {
      this.options = {
        // environment: 'PRODUCTION',
        environment: "TEST",
        buttonColor: "white",
        allowedCardNetworks: [
          "AMEX",
          "DISCOVER",
          "INTERAC",
          "JCB",
          "MASTERCARD",
          "VISA",
        ],
        allowedCardAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
        merchantInfo: {
          // merchantName: this.restaurant.googlepay.merchantName,
          // merchantId: this.restaurant.googlepay.merchantId,
          merchantName: "Ihospitality",
          merchantId: "BCR2DN4TZCGNJMLG",
        },
        transactionInfo: {
          totalPriceStatus: "FINAL",
          totalPrice: `${parseFloat(
            newVal +
              this.total -
              (this.client_reservation && this.client_reservation.total * 1 > 0
                ? this.client_reservation.total * 1
                : 0)
          ).toFixed(2)}`,
          currencyCode: this.currentCurrency.currency_code,
          countryCode: "FR",
        },
      };
    },
  },
  computed: {
    ...mapGetters([
      "leader",
      "isloadingCheckingLeader",
      "client_reservation",
      "client",
      "configuration",

      "order",
      "checkList",

      "old_order",
      "isloadingOrder",
      "payement_config",
      "error_message",
      "menus",
      "programmeMenu",
      "clientProg",
      "cltprg",
    ]),
    images(){
      let obj ={}
      for(let i=0; i<this.listSections.length; i++){
        for(let j=0; j<this.listSections[i].sub_sections.length; j++){
          for(let k=0; k<this.listSections[i].sub_sections[j].items.length; k++){
            obj[this.listSections[i].sub_sections[j].items[k].title] = this.listSections[i].sub_sections[j].items[k].image;
          }
        }
      }
      return obj;
    },
    player_id() {
      return this.client ? this.client._id : null;
    },
    activeMenu() {
      return this.menus.find((itm) => itm.slugMenu == this.params.menu);
    },
    selectedTable() {
      return this.params.table;
    },
    paypal() {
      if (this.restaurant.modes) {
        if (this.restaurant.modes.paypal) {
          return {
            sandbox: this.restaurant.paypal.sandbox,
            production: this.restaurant.paypal.production,
          };
        }
      }
      return {
        sandbox: "",
        production: "",
      };
    },

    isRoomCharge() {
      if (!this.configuration) {
        return false;
      }
      return (
        this.configuration.selectedMediaChmabre &&
        this.configuration.selectedMediaChmabre.ObjectNumber
      );
    },
    modes() {
      if (this.restaurant.modes) {
        return this.restaurant.modes;
      }
      return {};
    },

    total_count() {
      let total = 0;
      this.reserved_items_client.map((item) => {
        console.log({ item: item });
        console.log({ total: total });
        total += item.quantity;
      });
      return total;
    },
    isNewOrder() {
      let istrue = true;
      this.reserved_items.map((itm, index) => {
        if (itm._id && this.player_id == itm.player_id) {
          istrue = false;
        }
      });
      return istrue;
    },
    reserved_items_client() {
      let items = [];

      this.reserved_items.map((itm, index) => {
        let price = itm.price ? itm.price : itm.unitPrice * 1;
        if (itm.player_id !== undefined && itm.player_id != null) {
          if (this.player_id == itm.player_id || this.showAll) {
            items.push({ ...itm, unitPrice: price, price: price, index });
          }
        } else {
          items.push({ ...itm, unitPrice: price, price: price, index });
        }
      });
      return items;
    },
    total: function () {
      let total = 0;
      this.values.map((id) => {
        // let item = this.reserved_items.find((res_item) => res_item._id == id);
        // let item = this.reserved_items.find((res_item) => res_item.menuItemId == id);
        let item = this.reserved_items.find((res_item) => {
          return res_item._id ? res_item._id == id : res_item.menuItemId == id;
        });
        total +=
          item.quantity * 1 * (item.price ? item.price : item.unitPrice * 1);
      });
      total -= this.total_check_discount;
      return total.toFixed(2);
    },
  },
  sockets: {
    connect: function () {
      console.log("socket connected");
    },
    triggerOrderReady(data) {
      if (this.clientProg._id == data._id) {
        alert("Votre commande est prête");

        var audio = new Audio("htttp://localhost:3333/ring1.mp3");
        audio.play();
      }
    },
    acceptRequestToJoin() {
      this.$modal.hide("askJoinWating");
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      this.CheckLeader({
        table,
        restaurant: restaurant_,
        menu: menu_,
        user_id: this.client._id,
        name: this.clientName,
        setName: true,
        socketId: this.$socket.id,
      });
      // this.$modal.show("SuccessJoin")
      this.$modal.hide("askJoinName");
    },
    JoinRequest: function (data) {
      this.requestJoin = data.guest;

      this.$modal.show("AcceptJoinRequest");

      console.log(data);
    },
    checkTableResult: function (data) {
      this.$modal.hide("splash");
      this.$modal.hide("loading");
      // this.$modal.hide("pending");
      // alert("yes")
      console.log({ data });
      if (data && data.data) {
        console.log("commitCheckTable");
        console.log({ data });
        this.commitCheckTable(data);

        this.res_to_download = data.data[data.data.length - 1];

        // alert("yes")
      }

      // console.log("checkTablePos")
    },

    newOrder: function (data) {
      // alert("yess")
      if (data.order) {
        this.res_to_download = data.order;
      }
      this.check_table_dispo();
    },
  },
  methods: {
    checkScreen() {
      if (this.order && this.order[0]) {
        if (this.order[0].menuItems.length == this.reserved_items.length) {
          if (!window.location.href.includes("success=true")) {
            this.$modal.show("order");
          }
          return;
        }
      }

      this.$modal.show("cart");
    },
    toFixed(val) {
      console.log({ val });
      return val.toFixed(2);
    },
    acceptJoin() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      if (table) {
        this.AcceptLeader({
          table,
          restaurant: restaurant_,
          menu: menu_,
          user_id: this.requestJoin._id,
        }).then(() => {
          this.$modal.hide("AcceptJoinRequest");
          this.CheckLeader({
            table,
            restaurant: restaurant_,
            menu: menu_,
            user_id: this.client._id,
            name: this.clientName,
            setName: true,
            socketId: this.$socket.id,
          });
        });
      }
    },
    sendClientName() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      if (table) {
        this.CheckLeader({
          table,
          restaurant: restaurant_,
          menu: menu_,
          user_id: this.client._id,
          name: this.clientName,
          setName: true,
          socketId: this.$socket.id,
        });
        this.$modal.show("askJoinWating");
      }
    },
    sendRequest() {
      this.$modal.hide("askJoin");
      if (!this.client.name || this.client.name == "") {
        this.$modal.show("askJoinName");
      } else {
        this.$modal.show("askJoinWating");
      }
    },
    SignIn() {
      let email = this.$refs.loginForm.email;
      let password = this.$refs.loginForm.password;

      const form = {
        email: email,
        password: password,
      };
      this.loginProg(form).then((res) => {
        if (res.ok) {
          // window.location.href = '/'
          // this.$router.push('/client')
          this.getClientProg();
          console.log(res.client);
          // this.addClientSuccess(res.client)
          // this.saveClient();
          // this.CheckOrder();
        }
        // this.$router.push('Login')
      });
    },
    fideliteorpay() {
      if (this.programmeMenu && this.programmeMenu[0]) {
        this.$modal.show("fidelite");
      } else this.$modal.show("split");
      // this.programmeMenu[0] ? this.$modal.show('fidelite') : this.$modal.show('payment')
    },
    OpenTransfert() {
      this.getOperaReservation(this.operaRef).then((res) => {
        console.log({ res });
        this.operaReservation = res.data.data.reservations.reservation[0];
        this.$modal.hide("reservation_code");
        this.$modal.show("transfert");
      });
    },
    SaveSignature() {
      if (this.signaturePad) {
        this.image = this.signaturePad.toDataURL();
        this.sendOrder(6);
      }
    },
    OpenSignature() {
      this.$modal.hide("transfert");
      this.$modal.show("signature");
      setTimeout(() => {
        const canvas = document.querySelector("canvas");
        console.log(canvas);
        this.signaturePad = new SignaturePad(canvas, {
          // dotSize:.2,
          minWidth: 0.5,
          maxWidth: 0.5,
          penColor: "black",
        });
      }, 600);
    },
    transfertChmabre() {
      this.$modal.show("reservation_code");
    },
    onBegin() {
      console.log("=== Begin ===");
    },
    onEnd() {
      console.log("=== End ===");
    },

    OverReservation() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }

      let restaurant_ = prams[prams.length - (pas + 1)];
      // let menu_ = prams[prams.length - pas];
      if (this.client_reservation) {
        // let date = this.client_reservation.date;

        let newItem = {
          ...this.client_reservation,
          status: "over",
        };

        this.updateStatusReservation({
          restaurant: restaurant_,
          reservation: this.client_reservation._id,
          data: { ...newItem },
        });
      }
    },
    ConfirmePin() {
      if (!this.client_reservation) {
        return;
      }
      this.showPinError = false;
      if (this.client_reservation.pin == this.pin) {
        this.$modal.hide("pin");

        let prams = window.location.href.split("?")[0].split("/");
        let pas = 1;
        let table = null;
        if (prams.length == 6) {
          table = prams[prams.length - 1];
          pas = 2;
        }

        let restaurant_ = prams[prams.length - (pas + 1)];
        let menu_ = prams[prams.length - pas];

        let date = this.client_reservation.date;

        let newItem = {
          ...this.client_reservation,
          status: "seated",
        };

        this.updateStatusReservation({
          restaurant: restaurant_,
          reservation: this.client_reservation._id,
          data: { ...newItem },
        });
      } else {
        this.showPinError = true;
      }
    },

    calculPoints() {
      let ttl = 0;
      console.log("asdasdasdasdasdasd");
      console.log(this.cltprg);
      if (this.cltprg) {
        for (let i = 0; i < this.cltprg.length; i++) {
          if (!isNaN(this.cltprg[i].points)) {
            ttl = ttl + this.cltprg[i].points;
          }
        }
        if (ttl < 0) ttl = 0;
        this.points_client = ttl;
        console.log({ ttl });

        return ttl.toFixed(2);
      }
    },
    calculEarn() {
      if (!this.programmeMenu || !this.programmeMenu[0]) {
        return 0;
      }
      let earnpts = this.programmeMenu[0].earn.point;
      let earnvalue = this.programmeMenu[0].earn.value;
      let montant = this.total;
      let points_gagnes = (montant * earnpts) / earnvalue;
      this.ptsg = points_gagnes;
      return points_gagnes;
    },

    // burndiscount() {
    //   let ttl = this.calculPoints();
    //   let testtotal = (this.total * 50) / 100;
    //   console.log("total des points " + ttl);
    //   console.log("moitié du montant " + testtotal);
    //   console.log("PTSBURN " + this.ptsburn);
    //   if (ttl * 1 <= this.ptsburn * 1) {
    //     return "Vous avez dépassé vos points";
    //   } else if (ttl * 1 >= this.ptsburn * 1) {
    //     this.valueconsom =
    //       (this.ptsburn * this.programmeMenu[0].burn.value) /
    //       this.programmeMenu[0].burn.point;
    //     console.log("valueconsom " + this.valueconsom);
    //     this.discount = this.total * 1 - this.valueconsom;

    //     console.log(this.dscnt);
    //     if (this.discount * 1 < this.total * 1) {
    //       this.dscnt = true;
    //       console.log(this.dscnt);
    //     } else this.dscnt = false;
    //     return this.discount;
    //   } else if (this.discount * 1 < testtotal * 1) {
    //     return "Vous ne pouvez pas dépasser 50% du total";
    //   }
    // },
    discountvalue() {
      // let ttl = this.calculPoints();
      // let total = this.total;
      // if (this.discount > 0 && this.discount * 1 < this.total * 1) {
      //   this.valueconsom = total - this.discount;
      //   console.log("DISCOUNT DIFFERENCE : " + this.valueconsom);
      //   this.ptsburn =
      //     (this.valueconsom * this.programmeMenu[0].burn.point) /
      //     this.programmeMenu[0].burn.value;
      //   console.log("PTSBURN " + this.ptsburn);

      //   if (this.ptsburn <= ttl) {
      //     this.dscnt = true;
      //     return this.ptsburn.toFixed(2);
      //   } else if (this.ptsburn > ttl) {
      //     this.dscnt = false;
      //     return "Vous n'avez pas assez de ";
      //   } else this.dscnt = false;
      // } else if (this.discount * 1 <= 0 || this.discount * 1 == this.total) {
      //   this.dscnt = false;
      //   this.ptsburn = 0;
      //   return this.ptsburn;
      // } else if (this.discount * 1 > this.total) {
      //   this.dscnt = false;
      //   return "Vous avez dépassé le montant total";
      // }
      let solde = this.pointsTomontant();
      console.log("SOLDE : " + solde);
      if (
        this.valueconsom <= solde &&
        this.valueconsom > 0 &&
        this.programmeMenu &&
        this.programmeMenu[0]
      ) {
        this.ptsburn =
          (this.valueconsom * this.programmeMenu[0].burn.point) /
          this.programmeMenu[0].burn.value;
        this.discount = this.total - this.valueconsom;
        this.dscnt = true;
        return this.ptsburn.toFixed(2);
      } else if (this.valueconsom * 1 == 0) {
        this.ptsburn = 0;
        this.discount = 0;
        this.dscnt = false;
        return this.ptsburn.toFixed(2);
      } else {
        this.discount = 0;
        this.dscnt = false;
        return "Vous avez dépassé votre solde";
      }
    },
    pointsTomontant() {
      if (!this.programmeMenu || !this.programmeMenu[0]) {
        return 0;
      }
      this.montant_client =
        (this.points_client * this.programmeMenu[0].burn.value) /
        this.programmeMenu[0].burn.point;
      return this.montant_client.toFixed(2);
    },
    startDownload() {
      let param = {
        rvcRef: this.order[0].header.rvcRef,
        checkRef: this.order[0].header.checkRef,
        restaurant: this.$route.params.restaurant,
      };
      this.downloadFile(param);
    },
    sendEmail() {
      this.generateBill(this.res_to_download).then((res) => {
        this.sendBill(this.res_to_download);
      });
    },
    setPourboir(val) {
      this.pourboir = val;
      this.showOther = false;
    },
    async initClicAndPay() {
      let $this = this;
      if (!$this.reference_payment) {
        let rslt = await this.sendOrder(null, true);
      }
      let res = await Axios.post(
        "htttp://localhost:3333/api/v1/web/clicandpay",
        {
          amount:
            this.total * 1 +
            this.pourboir * 1 -
            (this.client_reservation && this.client_reservation.total * 1 > 0
              ? this.client_reservation.total * 1
              : 0),
          currency: this.currentCurrency.currency_code,
          orderId: $this.reference_payment,
          customer: {
            email: this.client_form.email
              ? client_form.email
              : "tfkizim@gmail.com",
          },
          Authorization:
            "Basic MzM2NTkxNjU6dGVzdHBhc3N3b3JkXzFnNkI4QUJ4a3hrUWJ5dWMxYWZzR3RBakFseFFBZU5PekUxZDVjQnU4MkZmMw==",
        },
        {}
      )
        .then(function (result) {
          return result.data;
        })
        .then(function (result) {
          return result.body;
        })
        .catch((err) => {
          console.log({ err });
        });
      // .then(function(data) {
      //   return data
      // })
      this.clicToken = res.answer.formToken;

      var my_awesome_script = document.createElement("script");

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      let return_url = `htttp://localhost:3333/${restaurant_}/${menu_}?ref=${$this.reference_payment}1`;
      if (table) {
        return_url = `htttp://localhost:3333/${restaurant_}/${menu_}/${table}?ref=${$this.reference_payment}1`;
      }

      my_awesome_script.setAttribute(
        "src",
        "https://api-clicandpay.groupecdn.fr/static/js/krypton-client/V4.0/stable/kr-payment-form.min.js"
      );
      my_awesome_script.setAttribute(
        "kr-public-key",
        "33659165:testpublickey_udUn5ozc6NwSbM3r479WfIJQkot5O1gWabElhClL3MJNY"
      );
      my_awesome_script.setAttribute("kr-get-url-success", return_url);

      document.head.appendChild(my_awesome_script);

      console.log({ res });
    },
    applePay() {
      // var request = {
      //     version:3,
      //     countryCode: 'FR',
      //     merchantIdentifier: 'merchant.devmonresto',
      //     currencyCode: this.currentCurrency.currency_code,
      //     supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
      //     merchantCapabilities: ['supports3DS'],
      //     total: { label: 'Monresto.menu', amount: `${this.total}` },
      // }
      // var session = new   ApplePaySession(3, request);
      // console.log(session)

      // if (!ApplePaySession) {
      //     return;
      // }

      // Define ApplePayPaymentRequest
      const request = {
        countryCode: "FR",
        currencyCode: this.currentCurrency.currency_code,
        merchantCapabilities: [
          "supports3DS",
          "supportsCredit",
          "supportsDebit",
        ],
        supportedNetworks: ["visa", "masterCard", "amex", "discover"],
        total: {
          label: "Monresto.menu",
          type: "final",
          amount: `${parseFloat(
            this.total * 1 +
              this.pourboir * 1 -
              (this.client_reservation && this.client_reservation.total * 1 > 0
                ? this.client_reservation.total * 1
                : 0)
          ).toFixed(2)}`,
        },
      };

      // Create ApplePaySession
      const session = new ApplePaySession(3, request);

      session.onvalidatemerchant = async (event) => {
        // Call your own server to request a new merchant session.
        let restaurant = this.$route.params.restaurant;
        let merchantSession = await this.validateMerchant(
          event.validationURL,
          restaurant
        );
        merchantSession = JSON.parse(merchantSession.data.body.body);
        console.log({ merchantSession });
        // alert("onvalidatemerchant")
        session.completeMerchantValidation(merchantSession);

        // const result = {
        //     "status": ApplePaySession.STATUS_SUCCESS
        // };
        // console.log(result);
        // session.completePayment(result);
      };

      session.onpaymentmethodselected = (event) => {
        // Define ApplePayPaymentMethodUpdate based on the selected payment method.
        // No updates or errors are needed, pass an empty object.
        // alert("onpaymentmethodselected")
        const update = {};
        session.completePaymentMethodSelection({
          newTotal: request.total,
          newLineItems: [],
        });
      };

      session.onshippingmethodselected = (event) => {
        // Define ApplePayShippingMethodUpdate based on the selected shipping method.
        // No updates or errors are needed, pass an empty object.
        // alert("onshippingmethodselected")
        const update = {};
        session.completeShippingMethodSelection(update);
      };

      session.onshippingcontactselected = (event) => {
        // Define ApplePayShippingContactUpdate based on the selected shipping contact.
        // alert("onshippingcontactselected")
        const update = {};
        session.completeShippingContactSelection(update);
      };

      session.onpaymentauthorized = (event) => {
        // Define ApplePayPaymentAuthorizationResult
        // alert("onpaymentauthorized")
        // alert(JSON.stringify(ApplePaySession));
        const result = {
          status: ApplePaySession.STATUS_SUCCESS,
        };
        // alert("onpaymentauthorized")
        session.completePayment(result);
        this.sendOrder(3);
      };

      session.oncancel = (event) => {
        // Payment cancelled by WebKit
      };

      session.begin();
    },
    // async validateMerchant(url, restaurant) {
    async validateMerchant(url) {
      // return Axios.get(`htttp://localhost:3333/applePay/${restaurant}`);
      return Axios.get("htttp://localhost:3333/applePay");
      // return Axios.post("htttp://localhost:3333/applePay",{
      //     merchantIdentifier:"merchant.devmonresto",
      //     displayName:"Monresto",
      //     initiative:"web",
      //     initiativeContext:"demo.monresto.menu"
      // })
    },
    minusCovers() {
      if (this.covers > 1) {
        this.covers--;
      }
    },
    addCovers() {
      this.covers++;
    },
    processPayment(paymentData) {
      // process payment
      console.log(paymentData);
      this.sendOrder(3);
    },
    handleCancel() {
      // handle cancel event
    },
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      console.log({ FB, scope });
    },

    loginFacebook(user) {
      console.log(user);

      this.FB.api(
        `/${user.authResponse.userID}?fields=id,first_name,last_name,email,picture`,
        function (response) {
          console.log({ response });
          if (response && !response.error) {
            this.client_form = {
              nom: response.last_name,
              prenom: response.first_name,
              email: response.email,
              image: response.picture.data.url,
            };
          }
        }
      );
    },

    onSuccess(googleUser) {
      console.log(googleUser);
      console.log("getAuthResponse");
      console.log(googleUser.getAuthResponse());

      let user = googleUser.getBasicProfile();
      console.log({ user });
      this.client_form = {
        nom: user.getFamilyName(),
        prenom: user.getName(),
        email: user.getEmail(),
        image: user.getImageUrl(),
      };
      console.log(this.client_form);
    },
    onFailure(googleUser) {
      console.log(googleUser);

      // This only gets the user information: id, name, imageUrl and email
    },
    showAllBill() {
      this.showAll = !this.showAll;
    },
    onOpened() {
      window.scrollTo(0, 1);
      document.getElementsByTagName("html")[0].classList.add("modal-opened");
    },
    onClosed() {
      document.getElementsByTagName("html")[0].classList.remove("modal-opened");
    },
    contentClick(e) {
      console.log(e, "content click");
    },
    itemClick(e) {
      console.log(e, "item click");
    },
    itemDblClick(e) {
      console.log(e, "item double click");
    },
    fbClick(e) {
      console.log(e, "First Button Click");
    },
    sbClick(e) {
      console.log(e, "Second Button Click");
    },
    triggerValues(id) {
      if (this.cart_button_text != "Payer ma commande") {
        return;
      }
      if (this.values.includes(id)) {
        this.values.splice(this.values.indexOf(id), 1);
      } else {
        this.values.push(id);
      }
    },
    checkOrder() {
      if (this.pendingPayment) {
        this.pendingPayment = false;
        this.$modal.hide("client");
        this.$modal.show("payment");
        return;
      }
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      if (table !== null) {
        this.sendOrder();
      } else {
        this.$modal.show("payment");

        //  this.$modal.show("order");
      }
    },
    UpdateFact() {
      if (this.order && this.order[0]) {
        if (this.order[0].menuItems.length == this.reserved_items.length) {
          this.$modal.hide("cart");
          return;
        }
      }
      this.sendOrder(null);
    },
    sendOrderDirect() {
      if (this.showAll) {
        this.payOrLogin();
        return;
      }
      this.sendOrder(null);
    },
    payOrLogin() {
      if (!this.clientProg) {
        this.pendingPayment = true;
        this.$modal.show("client");
      } else {
        this.$modal.show("payment");
      }
    },
    showClientInfos() {
      // alert("dd")
      if (this.order) {
        if (this.order._id) {
          this.$modal.show("split");
          // this.$modal.show('payment');
          return;
        }
      }
      console.log(window.location.href);

      this.$modal.show("client");

      // this.isValidSignature({url:window.location.href}).then((res)=>{
      //   console.log(res)
      //   if(res.valid){
      //     this.$modal.show('client')
      //   }else{
      //    this.$modal.show('client')
      //     // this.$modal.show("expire");
      //   }
      // })
    },
    async initStripe() {
      let $this = this;
      this.stripe = Stripe(this.restaurant.stripe.key);
      var elements = this.stripe.elements();
      var stripe = this.stripe;
      this.showStripe = true;
      document.getElementById("submit").disabled = true;
      if (!$this.reference_payment) {
        let rslt = await this.sendOrder(null, true);
      }

      fetch("htttp://localhost:3333/api/v1/web/create-payment-intent", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ref: $this.reference_payment,
          reserved_items: this.reserved_items,
          total:
            this.total * 1 +
            this.pourboir * 1 -
            (this.client_reservation && this.client_reservation.total * 1 > 0
              ? this.client_reservation.total * 1
              : 0),
          currency: this.currentCurrency.currency_code,
          restaurant: this.restaurant.slug,
        }),
      })
        .then(function (result) {
          return result.json();
        })
        .then(function (data) {
          var style = {
            base: {
              color: "#32325d",
              fontFamily: "Roboto, sans-serif",
              fontSmoothing: "antialiased",
              fontSize: "16px",
              "::placeholder": {
                color: "#32325d",
              },
            },
            invalid: {
              fontFamily: "Roboto, sans-serif",
              color: "#fa755a",
              iconColor: "#fa755a",
            },
          };
          var card = elements.create("card", { style: style });
          // Stripe injects an iframe into the DOM
          card.mount("#card-element");

          card.on("change", function (event) {
            // Disable the Pay button if there are no card details in the Element
            document.querySelector("#submit").disabled = event.empty;
            document.querySelector("#card-error").textContent = event.error
              ? event.error.message
              : "";
          });
          var form = document.getElementById("payment-form");
          form.addEventListener("submit", function (event) {
            event.preventDefault();
            // Complete payment when the submit button is clicked
            payWithCard(stripe, card, data.clientSecret);
          });
          var payWithCard = function (stripe, card, clientSecret) {
            loading(true);
            stripe
              .confirmCardPayment(clientSecret, {
                payment_method: {
                  card: card,
                },
              })
              .then(function (result) {
                console.log({ result });
                if (result.error) {
                  // Show error to your customer
                  showError(result.error.message);
                } else {
                  // The payment succeeded!
                  $this.getOrderbyRef({
                    ref: result.paymentIntent.description,
                    callback: (order) => {
                      console.log(order);
                      console.log("alksd;lasjljasldj;l");

                      $this.sendOrder(3);

                      // this.downloadFile(order);
                    },
                  });

                  orderComplete(result.paymentIntent.id);
                }
              });
          };
          /* ------- UI helpers ------- */
          // Shows a success message when the payment is complete
          var orderComplete = function (paymentIntentId) {
            loading(false);

            console.log(paymentIntentId);
            document
              .querySelector(".result-message a")
              .setAttribute(
                "href",
                "https://dashboard.stripe.com/test/payments/" + paymentIntentId
              );
            document
              .querySelector(".result-message")
              .classList.remove("hidden");
            document.querySelector("button").disabled = true;
          };
          // Show the customer the error from Stripe if their card fails to charge
          var showError = function (errorMsgText) {
            loading(false);
            var errorMsg = document.querySelector("#card-error");
            errorMsg.textContent = errorMsgText;
            setTimeout(function () {
              errorMsg.textContent = "";
            }, 4000);
          };
          // Show a spinner on payment submission
          var loading = function (isLoading) {
            if (isLoading) {
              // Disable the button and show a spinner
              document.querySelector("button").disabled = true;
              document.querySelector("#spinner").classList.remove("hidden");
              document.querySelector("#button-text").classList.add("hidden");
            } else {
              document.querySelector("button").disabled = false;
              document.querySelector("#spinner").classList.add("hidden");
              document.querySelector("#button-text").classList.remove("hidden");
            }
          };
        });
    },
    ...mapMutations(["addClientSuccess"]),
    ...mapActions([
      "AcceptLeader",
      "CheckLeader",
      "loginProg",
      "updateStatusReservation",
      "getReservationByTable",
      "getConfiguration",
      "addClient",
      "checkClient",
      "checkTable",
      "sendBill",
      "downloadFile",
      "generateBill",
      "postCheckGen2",
      "updateCheckGen2",
      "createOrder",
      "updateOrder",
      "getOrderbyRef",
      "getTablesDispos",
      "generatePaymentData",
      "isValidSignature",
      "commitCheckTable",
      "getOperaReservation",
      "getProgBymenu",
      "getClientProg",
      "earn",
      "rateserviceambiance",
      "getCheckListGn2",
    ]),
    accessCommande() {
      let flag = false;
      return true;
      if ((this.hasModule || this.hasCommande) && this.is_commande) {
        flag = true;
      } else {
        flag = false;
      }
      console.log("HEEEY : " + flag);
      console.log({
        hasModule: this.hasModule,
        hasCommande: this.hasCommande,
        is_commande: this.is_commande,
      });
      return flag;
    },
    authorized(param) {
      console.log("authorized");
      console.log(param);
    },
    completed(param) {
      console.log("completed");
      console.log(param);
      this.paypal_paiement = param;
      this.sendOrder(2);
    },
    cancelled(param) {
      console.log("cancelled");
      console.log(param);
    },
    sendUpdateOrder(payment, type_payement, data) {
      let newData = JSON.parse(JSON.stringify(data));
      newData.payment = payment;
      newData.order_id = this.order.CheckNum;
      newData.order_seq = this.order.CheckSeq;
      this.$modal.show("loading");
      this.updateOrder({
        data: newData,
      }).then((res) => {
        setTimeout(() => {
          this.$socket.emit("UpdateDefsSpecialCounts", {
            restaurant: this.params.restaurant,
            rvc: this.activeMenu.rvc,
          });
        }, 2000);

        if (res.ok === false) {
          this.$modal.show("error");
        } else if (
          payment * 1 !=
          this.configuration.selectedMediaEnvoi.ObjectNumber._text * 1
        ) {
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("success");

          this.$modal.hide("prepaiment");
          // this.$modal.show("success");
          this.$modal.show("rating");

          // this.res_to_download = res;

          this.OverReservation();

          let dt;
          // if (this.discount < this.total)
          if (this.clientProg && this.programmeMenu[0]) {
            if (this.dscnt) {
              dt = {
                // total: data.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: this.order._id,
                programme: this.programmeMenu[0]._id,
                total: this.discount,
                points_consommes: this.ptsburn,
              };
            } else {
              // console.log(data.total)
              console.log(this.discount);
              console.log(this.total);
              dt = {
                total: this.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: this.order._id,
                programme: this.programmeMenu[0]._id,
                // total: this.discount,
                points_gagnes: this.ptsg,
              };
            }
            console.log("dt : ", dt);
            this.earn(dt);
          }

          // FONCTION GAGNER DES POINTS
          // this.earn({
          //   total: data.total,
          //   menu: this.params.menu,
          //   restau: this.params.restaurant,
          //   client_id: this.clientProg._id,
          // });

          // this.downloadFile(res); // active
        } else {
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("success");

          this.$modal.hide("prepaiment");
          this.$modal.show("pending");
        }
      });

      // newData.rvc = $("#rvc").val();
    },
    async sendOrder(type_payement = null, is_payment = null) {
      // if (
      //   this.configuration.selectedMediaEscpece &&
      //   this.configuration.selectedTypeCommande
      // ) {
      // } else {
      //   this.$modal.show("error");
      //   return;
      // }

      this.$modal.show("loading");

      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      let menu_items = [];
      let payment = "";
      console.log("%c CONFIGURATION", "color:font-size:28px;");
      console.log(this.configuration);
      if (this.configuration) {
        switch (type_payement) {
          case 1:
            // espece
            if (this.configuration.selectedMediaEscpece) {
              // return;
              payment =
                this.configuration.selectedMediaEscpece.ObjectNumber._text;
            } else {
              payment = "";
            }
            break;
          case 2:
            // paypal
            if (this.configuration.selectedMediaPaypal) {
              payment =
                this.configuration.selectedMediaPaypal.ObjectNumber._text;
            } else {
              payment = "";
            }

            break;
          case 3:
            // credit card
            if (this.configuration.selectedMediaCreditCard) {
              payment =
                this.configuration.selectedMediaCreditCard.ObjectNumber._text;
            } else {
              payment = "";
            }
            break;
          case 6:
            // credit card
            if (this.configuration.selectedMediaChmabre) {
              payment =
                this.configuration.selectedMediaChmabre.ObjectNumber._text;
            } else {
              payment = "";
            }

            //  if (this.configuration.selectedMediaEnvoi) {
            //   payment = this.configuration.selectedMediaEnvoi.ObjectNumber._text;
            // } else {
            //   payment = "";
            // }
            break;

          default:
            // send
            if (this.configuration.selectedMediaEnvoi) {
              payment =
                this.configuration.selectedMediaEnvoi.ObjectNumber._text;
            } else {
              payment = "";
            }
            break;
        }
      } else {
        payment = "";
      }

      if (
        ((!this.order || this.order._id) && this.values.length == 0) ||
        !this.params.table
      ) {
        this.values = this.reserved_items.map((itm) => itm._id);
      }

      let isUpdate = false;
      if (this.configuration) {
        isUpdate =
          payment == this.configuration.selectedMediaEnvoi?.ObjectNumber._text;
      }

      let total_order = 0;
      let total_pay = 0;
      this.values.map((id, index) => {
        if (
          !this.old_order1.menu_items ||
          this.old_order1.menu_items.length <= index
        ) {
          // let item = this.reserved_items.find((res_item) => res_item._id == id);
          // let item = this.reserved_items.find((res_item) => res_item.menuItemId == id);
          let item = this.reserved_items.find((res_item) => {
            return res_item._id
              ? res_item._id == id
              : res_item.menuItemId == id;
          });
          let price = item.price ? item.price : item.unitPrice;
          price = parseFloat(price).toFixed(2);

          total_order += price * 1;
          menu_items.push({
            MiMasterObjNum: item.objectNumber
              ? item.objectNumber
              : item.MiMasterObjNum
              ? item.MiMasterObjNum
              : item.menuItemId,
            price: price,
            quantity: item.quantity,
            player_id: this.client ? this.client._id : null,
            title: item.title ? item.title : item.name,
            discount: null,
          });

          if (!isUpdate) {
            total_pay += price * 1;
          }
        } else {
          let item = this.reserved_items.find((res_item) => {
            return res_item._id
              ? res_item._id == id
              : res_item.menuItemId == id;
          });
          let price = item.price ? item.price : item.unitPrice;
          price = parseFloat(price).toFixed(2);
          total_order += price * 1;
          if (!isUpdate) {
            total_pay += price * 1;
          }

          // menu_items.push(
          //   {
          //     MiMasterObjNum: item.objectNumber
          //       ? item.objectNumber
          //       : item.MiMasterObjNum ? item.MiMasterObjNum : item.menuItemId,
          //     price: price,
          //     quantity: item.quantity,
          //     player_id: this.client ? this.client._id : null,
          //     title: item.title ? item.title : item.name,
          //     discount: null,
          //   }
          // )
        }
      });

      // alert(`${this.configuration.selectedMediaEnvoi?.ObjectNumber._text} == ${payment}`)
      // alert(this.configuration.selectedMediaEnvoi?.ObjectNumber._text == payment)
      // alert(isUpdate)
      // alert(total_pay)
      // return

      let t = "";
      // if (this.hasCommande * 1 == 0) {
      //   t = "web";
      // }
      if (this.configuration && this.configuration.selectedTypeCommande) {
        t = this.configuration.selectedTypeCommande.OrdTypeID._text;
      } else {
        t = "web";
      }

      //

      let data = {
        menu: this.params.menu,
        menu_items,
        payment,
        isUpdate,
        state:
          this.values.length == this.reserved_items.length
            ? isUpdate
              ? 0
              : 1
            : 0,
        total: this.discount,
        pourboir: this.pourboir,
        type: t,
        user: 90029,
        image: this.image,
        operaRef: this.operaRef,
        restau: this.params.restaurant,
        table: this.params.table,
        CheckNum: this.order.CheckNum,
        CheckSeq: this.order.CheckSeq,
        client_id: this.clientProg ? this.clientProg._id : null,
        paypal_paiement: this.paypal_paiement,
        menu: menu_,
        values: menu_items.map((itm) => {
          return { item: itm };
        }),
        currency_code: this.currentCurrency.symbol,
        // discount: this.calculEarn
        discount: this.dscnt,
        discount_amount: this.valueconsom,
        servicerating: this.servicerating,
        ambiancerating: this.ambiancerating,
      };
      let tendersGen2 = [
        {
          tenderId: parseInt(payment),
          total: total_pay,
        },
      ];
      let dataGen2 = {
        menu: this.params.menu,
        menu_items,
        user: 90001,
        restaurant: this.params.restaurant,
        resto_slug: this.params.restaurant,
        values: menu_items.map((itm) => {
          return { item: itm };
        }),
        rvcRef: this.activeMenu.rvc,
        tableName: this.params.table,
        seat: this.params.table,
        payment: payment,
        tenders: tendersGen2,

        total: this.discount,
        menu: this.params.menu,
        client_id: this.clientProg ? this.clientProg._id : null,
      };
      let dataUpdateGen2 = {
        menu: this.params.menu,
        menu_items,
        user: 90001,
        restaurant: this.params.restaurant,
        resto_slug: this.params.restaurant,
        values: menu_items.map((itm) => {
          return { item: itm };
        }),
        rvcRef: this.activeMenu.rvc,
        tableName: this.params.table,
        seat: this.params.table,
        payment: payment,
        tenders: tendersGen2,

        total: this.discount,
        image: this.image,
        menu: this.params.menu,
        client_id: this.clientProg ? this.clientProg._id : null,
        status: total_pay == total_order ? "closed" : "open",
        checkRef: this.checkList?.items?.[0]?.header?.checkRef,
      };

      // console.log({dataUpdateGen2,data})
      // return
      // console.log({config:this.configuration})
      // return {ok:true}

      // console.log({dataUpdateGen2})
      // return;

      let isNewUpdate = false; // to check if scan the qrcode at the same time ( to add this items to the existing order )

      if (!this.order || !this.order._id) {
        //let re = await this.check_table_dispo();
        if (this.order) {
          isNewUpdate = isUpdate;
        }
      }

      data.isNewUpdate = isNewUpdate;

      if (this.order) {
        if (this.order._id) {
          return await this.sendUpdateOrder(payment, type_payement, data);
        }
      }
      if (this.checkList.items && this.checkList.items.length > 0) {
        // alert("test1")
        // return;
        return await this.updateCheckGen2({ dataUpdateGen2 }).then(() => {
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("success");

          this.$modal.hide("prepaiment");
          // this.$modal.show("success");
          this.$modal.show("rating");
        });
      }

      // this.$socket.emit('receiveOrder', data)

      return await this.postCheckGen2({ dataGen2 }).then((res) => {
        if (type_payement == null) {
          if (is_payment) {
            this.reference_payment = res.ref;

            this.$modal.hide("loading");
          } else {
            this.$modal.hide("success");
            this.$modal.hide("payment");
            this.$modal.hide("client");
            this.$modal.hide("cart");
            this.$modal.hide("loading");
            this.$modal.hide("prepaiment");
            if (this.params.table) {
              this.$modal.show("pending");
            }
          }
        } else {
          this.$modal.hide("loading");
          this.$modal.hide("payment");
          this.$modal.hide("client");
          this.$modal.hide("cart");
          this.$modal.hide("loading");
          this.$modal.hide("prepaiment");
          // this.$modal.show("success");
          this.$modal.show("rating");

          // PROGRAMME FIDELITE FONCTION GAGNER ET CONSOMMER DES POINTS
          let dt;
          // if (this.discount < this.total)
          if (this.clientProg && this.programmeMenu[0]) {
            if (this.dscnt) {
              dt = {
                // total: data.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: res._id,
                programme: this.programmeMenu[0]._id,
                total: this.discount,
                points_consommes: this.ptsburn,
              };
            } else {
              console.log(data.total);
              console.log(this.discount);
              console.log(this.total);
              dt = {
                total: this.total,
                menu: this.params.menu,
                restau: this.params.restaurant,
                client_id: this.clientProg._id,
                commande: res._id,
                programme: this.programmeMenu[0]._id,
                // total: this.discount,
                points_gagnes: this.ptsg,
              };
            }
            console.log("dt : ", dt);
            this.earn(dt);
          }
          // this.downloadFile(res); //active
        }
      });
      return await this.createOrder({
        data,
        callback: (res) => {
          setTimeout(() => {
            console.log(this.$socket);
            console.log({
              restaurant: this.params.restaurant,
              rvc: this.activeMenu.rvc,
            });
            this.$socket.emit("UpdateDefsSpecialCounts", {
              restaurant: this.params.restaurant,
              rvc: this.activeMenu.rvc,
            });
          }, 2000);
          if (res.ok === false) {
            this.$modal.show("error");
          } else {
            // this.res_to_download = res;

            if (type_payement == null) {
              if (is_payment) {
                this.reference_payment = res.ref;

                this.$modal.hide("loading");
              } else {
                this.$modal.hide("success");
                this.$modal.hide("payment");
                this.$modal.hide("client");
                this.$modal.hide("cart");
                this.$modal.hide("loading");
                this.$modal.hide("prepaiment");
                if (this.params.table) {
                  this.$modal.show("pending");
                }
              }
            } else {
              this.$modal.hide("loading");
              this.$modal.hide("payment");
              this.$modal.hide("client");
              this.$modal.hide("cart");
              this.$modal.hide("loading");
              this.$modal.hide("prepaiment");
              // this.$modal.show("success");
              this.$modal.show("rating");

              // PROGRAMME FIDELITE FONCTION GAGNER ET CONSOMMER DES POINTS
              let dt;
              // if (this.discount < this.total)
              if (this.clientProg && this.programmeMenu[0]) {
                if (this.dscnt) {
                  dt = {
                    // total: data.total,
                    menu: this.params.menu,
                    restau: this.params.restaurant,
                    client_id: this.clientProg._id,
                    commande: res._id,
                    programme: this.programmeMenu[0]._id,
                    total: this.discount,
                    points_consommes: this.ptsburn,
                  };
                } else {
                  console.log(data.total);
                  console.log(this.discount);
                  console.log(this.total);
                  dt = {
                    total: this.total,
                    menu: this.params.menu,
                    restau: this.params.restaurant,
                    client_id: this.clientProg._id,
                    commande: res._id,
                    programme: this.programmeMenu[0]._id,
                    // total: this.discount,
                    points_gagnes: this.ptsg,
                  };
                }
                console.log("dt : ", dt);
                this.earn(dt);
              }
              // this.downloadFile(res); //active
            }
          }
          return res;
        },
      });
    },
    async moneticoC3() {
      // alert("sss")
      let checkRef = this.checkList.items[0].header.checkRef;
      let totalDue = this.checkList.items[0].totals.totalDue;
      let response = await axios.post(
        "htttp://localhost:3333/api/3c-payment/initiate",
        {
          amount: totalDue * 100,
          currency: "EUR",
          orderId: checkRef,
          returnUrl:
            window.location.origin + window.location.pathname + "?success=true",
          cancelUrl:
            window.location.origin + window.location.pathname + "?failed=true",
        }
      );
      console.log(response);
      if (response.data && response.data.success) {
        let initData = response.data.data;
        let transactionId = initData.transactionId;
        // /api/3c-payment/process

        let processResponse = await axios
          .post("htttp://localhost:3333/api/3c-payment/process", {
            transactionId: transactionId,
            cardDetails: {
              cardNumber: "5500000000000004",
              expiryMonth: "06",
              expiryYear: "2028",
              cvv: "123",
              amount: totalDue * 100,
              currency: "EUR",
            },
          })
          .then((res) => res.data);
        console.log({ processResponse });

        if (processResponse.success) {
          location.href = processResponse.data.paymentUrl;
        } else {
          console.error("Error:", processResponse.message);
        }

        // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?failed=true&datatransTrxId=250716213142880566
        // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?success=true&datatransTrxId=250716213638480777
      }

      alert("Monetico C3 payment not implemented yet");
    },
    moneticoPayment() {
      let menu_items = [];
      let payment = "";
      let type = "web";
      if (this.configuration.selectedMediaCreditCard) {
        payment = this.configuration.selectedMediaCreditCard.ObjectNumber._text;
      }
      if (this.configuration.selectedTypeCommande) {
        type = this.configuration.selectedTypeCommande.OrdTypeID._text;
      }

      this.reserved_items.map((item) => {
        let price = item.price;
        price = parseFloat(price).toFixed(2);
        menu_items.push({
          MiMasterObjNum: item.objectNumber,
          price: price,
          quantity: item.quantity,
          title: item.title,
          discount: null,
        });
      });

      let data = {
        menu: this.params.menu,
        menu_items,
        payment,
        type: this.hasCommande * 1 == 0 ? "web" : type,
        user: 90029,
        restau: this.params.restaurant,
        table: this.params.table,
        CheckNum: this.order.CheckNum,
        CheckSeq: this.order.CheckSeq,
        reference: this.order.ref,
        pourboir: this.pourboir,
        client_id: this.clientProg ? this.clientProg._id : "",
        paypal_paiement: this.paypal_paiement,
        is_new_v: 1,
        currency_code: this.currentCurrency.symbol,
        // discount: this.calculEarn
        discount: this.dscnt,
      };

      this.generatePaymentData({
        data,
        callback: (res) => {
          if (res.ok === false) {
            this.$modal.show("error");
          } else {
            this.$refs.payment_form.submit();
            // this.$modal.show('success')
            // this.downloadFile(res);
          }
        },
      });
    },
    saveClient() {
      // let params = {
      //   client: { ...this.client_form, restaurant: this.restaurant.slug },
      // };
      // if (this.player_id) {
      //   params.client.key = this.player_id;
      // }
      // this.addClient(params).then((res) => {

      // });

      this.checkOrder();
    },
    closeAll() {
      let url = window.location.href.split("?")[0];
      // this.$modal.hide("success");
      // this.$modal.show("loading");

      window.location.href = url;
      // setTimeout(() => {
      //   this.check_table_dispo();
      // }, 2000);
    },
    refreshAll() {
      let url = window.location.href.split("?")[0];
      // this.$modal.hide("success");
      // this.$modal.show("loading");

      window.location.href = url;
      // window.location.reload();

      //this.$modal.show("loading");

      // // window.location.href = url;
      // setTimeout(() => {
      //   this.check_table_dispo();
      // }, 2000);
    },

    passRating() {
      if (this.order) {
        let payload = {
          order_id: this.order._id,
          ambiancerating: this.ambiancerating,
          servicerating: this.servicerating,
        };
        this.rateserviceambiance(payload);
      }

      this.$modal.hide("pending");
      if (this.order[0].menuItems.length != this.reserved_items.length) {
        this.closeAll();
      } else {
        this.$modal.show("success");
      }
      //
      // Hamza
    },

    closeAllPopups() {
      this.$modal.hide("order");
      this.$modal.hide("success");
      this.$modal.hide("payment");
      this.$modal.hide("client");
      this.$modal.hide("cart");
      this.$modal.hide("loading");
      // this.$modal.hide("pending");
      this.$modal.hide("expire");
      this.$modal.hide("prepaiment");
    },
    check_table_dispo() {
      let prams = window.location.href.split("?")[0].split("/");
      let pas = 1;
      let table = null;
      if (prams.length == 6) {
        table = prams[prams.length - 1];
        pas = 2;
      }
      let restaurant_ = prams[prams.length - (pas + 1)];
      let menu_ = prams[prams.length - pas];
      this.params = {
        restaurant: restaurant_,
        menu: menu_,
        table: table,
      };

      this.$socket.emit("checkTable", {
        restaurant: restaurant_,
        table,
        menu: menu_,
        client_id: this.client ? this.client._id : null,
      });

      // return this.checkTable({
      //   restaurant: restaurant_,
      //   table,
      //   menu: menu_,
      //   client_id: this.player_id,
      // }).then((res) => {
      //   this.$modal.hide("splash");
      //   return res;
      // });
    },
  },

  mounted() {
    console.log("this.$socket");
    console.log(this.$socket);
    let prams1 = window.location.href.split("?")[0].split("/");
    let pas1 = 1;

    let restaurant = this.$route.params.restaurant;
    let tableName = null;
    if (prams1.length == 6) {
      tableName = prams1[prams1.length - 1];

      pas1 = 2;
    }
    let payload = {
      restaurant: restaurant,
      resto_slug: restaurant,
      // rvcRef: 101,
      tableName: tableName,
      menu: this.$route.params.menu,
    };
    this.$modal.hide("order");
    this.getCheckListGn2(payload).then(() => {
      console.log({ checkList: this.checkList });
      if (this.checkList.items.length > 0) {
        console.log({ ordergen2: this.checkList.items[0] });
        this.reserved_items = this.checkList.items[0].menuItems;
        // alert("dddd")
        if (this.checkList.items[0].totals.subtotalDiscountTotal != 0) {
          this.total_check_discount =
            -1 * this.checkList.items[0].totals.subtotalDiscountTotal;
        }
        this.old_order1 = { menu_items: this.checkList.items[0].menuItems };
        this.cart_button_text = "Payer ma commande";

        if (window.location.href.includes("success=true")) {
          this.$modal.hide("order");
          setTimeout(() => {
            this.$modal.hide("order");
            let queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);
            let datatransTrxId = urlParams.get("datatransTrxId");
            if (datatransTrxId && this.checkList.items.length > 0) {
              axios
                .post(`htttp://localhost:3333/api/3c-payment/verify`, {
                  transactionId: datatransTrxId,
                })
                .then((res) => {
                  console.log(res.data);
                  if (res.data.success && res.data.data.status === "settled") {
                    setTimeout(() => {
                      this.sendOrder(3);
                    }, 900);
                  } else {
                    this.$modal.show("error_payment");
                  }
                })
                .catch((err) => {
                  console.error(err);
                  this.$modal.show("error_payment");
                });
              // this.isValidSignature({
              //   data: { datatransTrxId },
              //   callback: (res) => {
              //     if (res.ok) {
              //       this.$modal.show("success");
              //     } else {
              //       this.$modal.show("error_payment");
              //     }
              //   },
              // });
            } else {
              // this.$modal.show("success");
              this.$modal.show("order");
            }
          }, 200);
        }
        {
          this.$modal.show("order");
        }
      }
    });

    // this.$modal.show('askJoin')
    this.getProgBymenu({
      restaurant: this.$route.params.restaurant,
      menu: this.$route.params.menu,
    });
    this.getClientProg();
    let prams = window.location.href.split("?")[0].split("/");
    let pas = 1;
    let table = null;
    if (prams.length == 6) {
      table = prams[prams.length - 1];

      pas = 2;
    }

    let restaurant_ = prams[prams.length - (pas + 1)];
    let menu_ = prams[prams.length - pas];
    this.params = {
      restaurant: restaurant_,
      menu: menu_,
      table: table,
    };
    this.getConfiguration(restaurant_);
    // this.checkClient(restaurant_);

    // let dateChecked = new Date().toISOString().split("T")[0];
    //       let heure =  moment().format("HH:mm");
    //       let data = this.getTablesDispos({
    //         slug: this.$route.params.restaurant,
    //         date: dateChecked,
    //         heure: heure,
    //         rvc: this.rvc.value,
    //     });
    // this.$modal.show("order");
    this.$modal.show("clicnt");

    if (table !== null) {
      this.$modal.show("splash");
      let hour = moment().format("HH:");
      // hour = "16:";
      this.getReservationByTable({ table, hour, restaurant: restaurant_ });

      setTimeout(() => {
        this.check_table_dispo();
      }, 10);

      setTimeout(() => {
        this.$modal.hide("splash");
      }, 400);
    } else {
      // alert("ss")

      this.$modal.hide("splash");
    }

    if (
      window.location.href.split("?")[1] &&
      window.location.href.includes("ref=")
    ) {
      const queryString = window.location.search;

      const urlParams = new URLSearchParams(queryString);
      let ref = urlParams.get("ref").substr(0, urlParams.get("ref").length - 1);
      let status = urlParams.get("ref").slice(-1);
      // alert(ref)
      if (status == 1) {
        // this.$modal.show("success");
      } else {
        this.$modal.show("error_payment");
      }
      this.getOrderbyRef({
        ref,
        callback: (order) => {
          console.log(order);
          console.log("alksd;lasjljasldj;l");

          if (status == 1) {
            setTimeout(() => {
              this.sendOrder(3);
            }, 1000);

            // this.downloadFile(order);
          }
        },
      });
    }
    // console.log({AACCCTTTIIIVVVEEE_MENU : this.activeMenu.rvc})

    // CHECK THE PAYMENT STATUS

    // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?failed=true&datatransTrxId=250716213142880566
    // http://192.168.100.225:8081/IHOSP-CLOUD-GEN2/Menu-1/3?success=true&datatransTrxId=250716213638480777
    // if (window.location.href.includes("success=true")) {
    //   setTimeout(() => {
    //   let queryString = window.location.search;
    //   let urlParams = new URLSearchParams(queryString);
    //   let datatransTrxId = urlParams.get("datatransTrxId");
    //   if (datatransTrxId && this.checkList.items.length > 0) {
    //       axios
    //       .post(
    //         `htttp://localhost:3333/api/3c-payment/verify`,
    //         { transactionId: datatransTrxId }
    //       )
    //       .then((res) => {
    //         console.log(res.data);
    //         if(res.data.success && res.data.data.status === "settled") {

    //            this.sendOrder(3);

    //         } else {
    //           this.$modal.show("error_payment");
    //         }
    //       })
    //       .catch((err) => {
    //         console.error(err);
    //         this.$modal.show("error_payment");
    //       });
    //     // this.isValidSignature({
    //     //   data: { datatransTrxId },
    //     //   callback: (res) => {
    //     //     if (res.ok) {
    //     //       this.$modal.show("success");
    //     //     } else {
    //     //       this.$modal.show("error_payment");
    //     //     }
    //     //   },
    //     // });
    //   } else {
    //     // this.$modal.show("success");
    //   }
    //   }, 1000);
    // } else if (window.location.href.includes("failed=true")) {
    //   this.$modal.show("error_payment");
    // }
  },
  created() {
    // this.$ws.$on(`START_ORDER`, (d) => {});
  },
};
</script>

<style>
#audio {
  /* opacity: 0;
  width: 1px;
  height: 1px;
  overflow: hidden; */
}

.profile_client_page {
  width: 100%;
  padding: 24px 12px;
  /* padding-top: 52px; */
  /* margin-bottom: 120px; */
  color: #fff;
}

.profile_header {
  display: flex;
  flex-direction: column;
  flex: 2;
  justify-content: center;
  align-items: flex-start;
  padding-left: 24px;
  position: relative;

}



.profile_title {
  font-size: 62px;
  font-weight: bold;
}

.profile_title1 {
  font-size: 62px;
  font-weight: bold;
  transform: rotate(5deg);
  position: relative;
  bottom: 20px;
}

.profile_circle {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 26%;
  left: 13px;
}

.profile_circle1 {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 41%;
  left: 120px;
}

.profile_circle2 {
  display: block;
  position: absolute;
  width: 25px;
  height: 25px;
  background: #f05d2e;
  border-radius: 50%;
  top: 62%;
  left: 19%;
}

.peofile_account {
  background: #fff;
  padding: 24px 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-radius: 5px;
  color: #264740;
  position: relative;
}

.profile_picture {
  background: #f05d2e;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_picture span {
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

.profile_infos {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding-left: 12px;
}

.profile_name {
  font-size: 20px;
  font-weight: bold;
  margin: 0px;
}

.profile_email {
  font-size: 14px;
  margin: 0px;
}

.profile_action {
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile_points {
  padding-top: 36px;
  padding-bottom: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.points_montant {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.profile_point1 {
  /* flex: 1; */
  padding: 30px 30px;
  /* background: #fff; */
  color: #f05d2e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* border-radius: 50%; */
  font-weight: 600;
  position: relative;
}

.profile_point1 i {
  color: #f05d2e;
}

.dot_profile_page {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: -10%;
  right: 10%;
}

.dot_profile_page1 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: 90%;
  left: 20%;
}

.dot_profile_page2 {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: 75%;
  left: 80%;
}

.dot_profile_page4 {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: #f05d2e;
  position: absolute;
  top: -10%;
  left: 120%;
}

.programme_details {
  padding: 14px 0;
  color: #f05d2e;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  border-radius: 5px;
  margin-top: 36px;
}

.programme_details hr {
  /* border-top: 3px solid #264740;
  border-bottom: 3px solid #264740; */
  border-color: #264740;
  background-color: #264740;
  width: 50%;
  display: flex;
  align-self: center;
}

.nom_programme {
  background-color: #f05d2e;
  color: #fff;
  font-weight: 600;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 10px;
}

.nom_programme h2 {
  margin: 0;
}

.earn_programme {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 80%;
  margin-bottom: 10px;
}

.points_e_program {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 5px 0;
}

.points_e_program span {
  margin: 2px 0;
  background-color: #264740;
  color: #fff;
  padding: 5px;
  width: 70px;
  border-radius: 5px;
}

.label_e_program {
  color: #264740;
  font-weight: 600;
}

.gain_earn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
  font-size: large;
}

.gain_consom {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px 0 20px 0;
}

.gain_consom .gain {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f05d2e;
  color: #fff;
  border-radius: 20px;
  padding: 10px;
  margin: 0 10px;
  user-select: none;
  width: 200px;
}

.eaarn {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
  font-size: large;
}

.hiden_audio {
  /* width: 0.5px;
  height: 0.5px; */
  /* opacity: 0; */
  /* overflow: hidden; */
  display: block;
}

.payment_icon {
  width: 30px;
}

.paypal_payment_icon {
  width: 87px !important;
  object-fit: contain !important;
  position: relative;
  top: 22px;
}

.paymement_button {
  border-radius: 5px !important;
  background: #fff !important;
  color: #264740 !important;
  display: flex;
  justify-content: space-between;
}

.paymement_button img {
  width: 32px;
  height: 32px;
  object-fit: cover;
}

.paymement_button.card {
  background-color: #0b6eaf;
}

.paymement_button.cash {
  background-color: #a9d696;
}

.hidden {
  height: 0px;
  width: 0px;
  overflow: hidden;
}

.paypal_button {
  background-color: #ffc439 !important;
  padding: 0px !important;
  position: relative;
  height: 80px;
}

.client_form_conainer {
  padding: 12px;
}

.bonjour {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
}

.modal_title {
  display: block;
  padding: 16px 12px;
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  /* letter-spacing: 1.5px; */
  background: #1baaae;
  background: black;
  /* color: #37474f; */
  width: 100%;
  text-align: center;
}

.remove {
  color: #ff8080;
}

.infos_td {
  text-align: left;
}

.full {
  width: 100%;
  flex: 1;
  margin-bottom: 80px;
}

.full.center {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0px !important;
  margin-bottom: 0px !important;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.modal_content {
  user-select: none;
  width: 100%;
  /* height: 100svh; */
  flex: 1;
  max-height: 100vh;
  flex: 1;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 0px;
  padding-top: 0px;
}

.close_modal {
  position: absolute;
  top: 6px;
  right: 6px;
  padding: 12px;
  color: #37474f;
  color: #fff;
}

.vm--container {
  z-index: 999999;
}

.vm--modal {
  width: 100% !important;
  min-height: 100svh;
  top: 0px !important;
  left: 0px !important;
}

.bottom_commande {
  position: fixed;
  bottom: 0px;
  background: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  left: 0px;
  /* display: none; */
}

.bottom_content {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 24px;
  background: transparent !important;
}

.bottom_content_box {
  background: #264740;
  /* width: 90%; */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 24px;
  border-radius: 50px;
  position: relative;
  bottom: 6px;
  flex: 1;
  text-align: right !important;
}

.count_articles {
  flex: 2;
  min-width: 75%;
  text-align: left;
}

.bottom_content span {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
}

.bottom_content i {
  color: #fff;
}

.table-image thead td,
.table-image thead th {
  border: 0;
  color: #666;
  font-size: 0.8rem;
}

.table-image thead td,
.table-image thead th {
  vertical-align: middle;
  text-align: center;
}

.qty {
  max-width: 2rem;
}

.price {
  margin-left: 1rem;
}

.modal-footer {
  padding-top: 0rem;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  /* height: 100%; */
  width: 100%;
  max-width: 773px;
  left: 22px;
  border-radius: 0px;
}

.close {
  font-size: 22px;
}

@media screen and (max-width: 600px) {
  .google_fb {
    flex-direction: row;
    position: absolute;
    top: 480px;
  }

  .google_login {
    width: 30px;
    opacity: 0;
    margin-left: -80px;
  }

  .fb_login {
    width: 20px;
    opacity: 0;
    margin-left: 20px;
  }
}

@media (min-width: 576px) {
  .vm--container {
    max-width: 100%;
    margin-left: 0;
  }
}

@media (min-width: 768px) {
  .vm--container {
    max-width: 720px;
    margin-left: calc((100% - 720px) / 2);
  }
}

@media (min-width: 992px) {
  .vm--container {
    max-width: 960px;
    margin-left: calc((100% - 960px) / 2);
  }
}

@media (min-width: 1200px) {
  .vm--container {
    max-width: 1140px;
    margin-left: calc((100% - 1140px) / 2);
  }

  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1140px;
    padding: 0px !important;
  }
}

@media (min-width: 1400px) {
  .vm--container {
    max-width: 1320px;
    margin-left: calc((100% - 1320px) / 2);
  }
}

/* @media only screen and (min-width: 1000px) {


.vm--container{
      max-width: 780px;
    margin-left: calc((100% - 780px)/2);
}

} */
@media only screen and (max-width: 500px) {
  .addTo {
    top: 50px;
  }

  .ajouter {
    right: 50px !important;
    top: -16px !important;
    font-size: 10px !important;
  }

  .price {
    font-size: 12px;
    margin-left: 16px;
    font-weight: 500;
    min-width: unset;
    display: block;
    position: relative;
    right: 0px !important;
    text-align: right;
  }
}

@media only screen and (max-width: 800px) {
  .category_title {
    position: relative;
    width: calc(100% - 20px);
    font-size: 18px;
    font-weight: bold;
    text-transform: uppercase;
    border-bottom: 6px solid black;
    margin-bottom: 24px;
    display: block;
    padding-bottom: 12px;
  }

  .price {
    left: 12px;
  }

  .addTo {
    top: 49px !important;
    right: 11px !important;
    font-size: 12px !important;
  }

  /* .item {
    display: flex;
    width: calc(100% - 26px) !important;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
    border-bottom: 1px solid #8080801c;
    padding-bottom: 12px;

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
} */

  .ajouter {
    font-size: 10px !important;
    right: 160px;
    top: 1px;
  }

  .price {
    font-size: 12px;
    margin-left: 16px;
    font-weight: 500;
    /* min-width: 80px; */
    display: block;
    position: relative;
    right: 0px !important;
    text-align: right;
  }

  .header,
  .body,
  .footer {
    width: 100%;
  }

  .subcategory_title {
    width: calc(100% - 0px) !important;
    right: 0px;
  }

  .category_title {
    width: calc(100% - 0px) !important;
    color: #fff;
    background: black;
    font-size: 16px !important;
    padding: 6px 12px !important;
  }

  .azour_body .category {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .azour_body .collapsed {
    right: 12px !important;
  }

  .modal-content {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: unset;
    border-radius: 0.3rem;
    outline: 0;
    /* height: 100%; */
    width: 100%;
    max-width: 756px;
    left: 0px;
    border-radius: 0px;
    min-height: 100%;
  }

  .modal {
    left: 0px;
    top: 0px;
    padding: 0px !important;
    height: 100%;
  }

  .modal.show .modal-dialog {
    width: 100%;
    margin: 0px;
    height: 100%;
  }

  .modal-title {
    font-size: 14px;
    text-transform: uppercase;
  }

  td {
    font-size: 12px;
    font-weight: normal;
  }

  th {
    font-size: 12px;
    font-weight: bold;
  }

  .text-left {
    text-align: left !important;
  }
}

.quantity {
  display: flex;
  justify-content: center;
  align-items: center;
}

.controls_container {
  vertical-align: middle !important;
}

span.quantity_value {
  font-size: 14px;
  margin: 0px 9px;
  color: #000;
  flex: 1;
}

span.plus {
  background: #1baaae !important;
}

span.plus,
span.minus {
  background: #1baaae;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 6px;
  /* border-radius: 50%; */
  vertical-align: middle;
  font-size: 7px;
  opacity: 0.9;
}

span.plus,
span.minus {
  background: #1baaae;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 3px;
  border-radius: 0px;
  vertical-align: middle;
  font-size: 7px;
  opacity: 0.9;
}

td {
  vertical-align: middle;
}

.remove {
  font-size: 18px !important;
  padding-right: 0px !important;
  text-align: right !important;
  width: 25px !important;
}

.bottom_commande_cart_half {
  flex-direction: column;
  justify-content: center;
  padding: 14px !important;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100%;
  padding-bottom: 24px;
}

.bottom_commande_cart {
  flex-direction: column;
  justify-content: center;
  padding: 14px !important;
  align-items: center;
  position: fixed;
  bottom: 0px;
  width: 100%;
  left: 0px;
  padding-bottom: 24px;
}

.modal_buttons {
  flex-direction: row;
  justify-content: space-between;
  padding: 14px !important;
  align-items: center;
  position: relative;
  /* position: absolute; */
  bottom: 0px;
  width: 100%;
  background: transparent !important;
}

#button_commander {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  margin-bottom: 12px;
  border-radius: 50px;
}

.button_commander_half {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: space-between;
  margin: 0px;
  margin-bottom: 12px !important;
  border-radius: 10px;
}

.button_commander {
  padding: 6px 12px;
  flex: 1;
  justify-content: flex-start;
  text-align: left;
}

.total {
  padding: 6px 12px;
}

.showAllBill {
  padding: 6px 12px;
  flex: 1;
  justify-content: center;
  text-align: center;
  width: calc(100% - 24px);
  background: #f05d2e;
}

#showAllBill {
  width: calc(100% - 24px);
  background: #f05d2e;
  background: #f05d2e;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 12px;
  border-radius: 50px;
  overflow: hidden;
}

#showAllBill1 .showAllBill {
  color: #f05d2e !important;
  text-decoration: underline !important;
  padding: 0px !important;
  background: transparent !important;
}

#showAllBill1 {
  width: calc(100% - 24px);
  background: transparent;
  color: #fff;
  padding: 6px;
  text-align: center;
  display: flex;
  justify-content: center;
  margin: auto;
  margin-bottom: 12px;
  border-radius: 50px;
  overflow: hidden;
}

.modal-header {
  background: #f05d2e;
  color: white;
  border-radius: 0px;
}

/* .modal.fade:not(.in).right .modal-dialog {
    -webkit-transform: translate3d(25%, 0, 0);
    transform: translate3d(25%, 0, 0);
} */

#payemnt_back {
  width: 100%;
  background: #f05d2e;
  color: #fff;
  /* padding: 12px; */
  text-align: center;
  display: flex;
  justify-content: flex-start;
  margin: 0px;
  align-items: center;
  padding-left: 20px;
  font-size: 12px;
}

.modal_button {
  flex: 1;
  width: auto;
  background: #f05d2e;
  color: #fff;
  /* padding: 12px; */
  text-align: center;
  display: flex;
  justify-content: center;
  margin: 0px 6px;
  align-items: center;
  padding: 12px;
  font-size: 12px;
  margin-top: 12px;
}

.modal_buttons {
  display: flex;
}

.paymement_buttons {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  padding: 12px;
  padding-bottom: 150px;
}

.google_pay {
  padding: 16px !important;
}

.paymement_button {
  width: 100%;
  color: #fff;
  padding: 22px;
  margin: 6px 0px;
  flex-direction: row;
  display: flex;
  align-items: center;
  /* margin: 0px 6px; */
  font-size: 12px;
}

.modal_button_text {
}

.client-form {
  margin-bottom: 18px;
  font-size: 12px;
  text-align: left;
}

.client-form label {
  margin-bottom: 3px;
}

input {
  font-size: 12px !important;
}

.center_content {
  justify-content: center;
  align-items: center;
  display: flex;
}

.success_message img {
  width: 60%;
  margin-bottom: 20px;
}

.error_img {
  width: 80% !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

@media only screen and (min-width: 1000px) {
  .error_img {
    width: 60% !important;
    margin-bottom: 20px !important;
    position: relative;
    bottom: 40px;
  }

  .success_message img {
    width: 30%;
    margin-bottom: 20px;
  }
}

.loading_img {
  width: 120px !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

.expire_img {
  width: 180px !important;
  margin-bottom: 20px !important;
  position: relative;
  bottom: 40px;
}

.success_message {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 100%;
  text-align: center;
  font-size: 14px;
  padding-bottom: 60px;
}

.pending_message {
  position: relative;
  bottom: 40px;
}

.form-control:focus {
  color: #212529;
  background-color: #fff;
  border-color: unset;
  outline: 0;
  box-shadow: unset;
}

.form-control {
  border-radius: 0px;
}

.loader {
  display: none;
  width: 100%;
  height: 100%;
}

.loader .loader_container {
  display: flex;
  width: 100%;
  height: 100%;
  padding-top: 50%;
  justify-content: center;
  align-items: center;
}

.lds-ripple {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-ripple div {
  position: absolute;
  border: 4px solid #000;
  opacity: 1;
  border-radius: 50%;
  animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
}

.lds-ripple div:nth-child(2) {
  animation-delay: -0.5s;
}

@keyframes lds-ripple {
  0% {
    top: 36px;
    left: 36px;
    width: 0;
    height: 0;
    opacity: 1;
  }

  100% {
    top: 0px;
    left: 0px;
    width: 72px;
    height: 72px;
    opacity: 0;
  }
}

/* Variables */
* {
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 16px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  justify-content: center;
  align-content: center;
  height: 100vh;
  width: 100vw;
}

/* form {
  width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
} */

input {
  border-radius: 6px;
  margin-bottom: 6px;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  font-size: 16px;
  width: 100%;
  background: white;
}

.result-message {
  line-height: 22px;
  font-size: 16px;
}

.result-message a {
  color: rgb(89, 111, 214);
  font-weight: 600;
  text-decoration: none;
}

.hidden {
  display: none;
}

#card-error {
  color: rgb(105, 115, 134);
  text-align: left;
  font-size: 13px;
  line-height: 17px;
  margin-top: 12px;
}

#card-element {
  border-radius: 4px 4px 0 0;
  padding: 12px;
  border: 1px solid rgba(50, 50, 93, 0.1);
  height: 44px;
  width: 100%;
  background: white;
}

#payment-request-button {
  margin-bottom: 32px;
}

/* Buttons and links */
button {
  background: #5469d4;
  color: #ffffff;
  font-family: Arial, sans-serif;
  border-radius: 0 0 4px 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}

button:hover {
  filter: contrast(115%);
}

button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}

.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}

.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}

.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}

.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  /* form {
    width: 80vw;
  } */
}

/* .card_monetico {
  border-radius: 5px;
  background: linear-gradient(68deg, #f28e09eb, #4c3040c9) !important;
}

.bitcoin_card {
  border-radius: 5px;
  background: linear-gradient(68deg, #f28e09eb, #f28e09eb) !important;
} */

#payment_form {
  width: 0.5px;
  height: 0.5px;
  opacity: 0;
  visibility: hidden;
}

@media only screen and (min-width: 800px) {
  /* .vm--modal {
    width: 88% !important;
    min-height: 100vh;
    top: 0px !important;
    left: 6% !important;
  } */
  span.plus,
  span.minus {
    background: black;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0px;
    border-radius: 0px;
    vertical-align: middle;
    font-size: 7px;
    opacity: 0.9;
    border-radius: 3px;
  }
}

.modal-footer {
  background: #fff;
}

.modal_content {
  overflow: overlay;
}

form#payment-form {
  margin-top: 12px;
  /* padding: 16px 56px; */
}

.modal_down::after {
  content: " ";
  display: block;
  width: 35px;
  height: 35px;
  background: transparent;
  position: absolute;
  top: 12px;
  right: 12px;
  background-image: url("htttp://localhost:3333/new_images/close.png");
  background-size: contain;
  background-position: center;
  cursor: pointer;
  z-index: 99;
}

.orange_text {
  color: #f05d2e;
}

input.pin_input {
  margin-top: 12px;
}

.pin_input {
  width: 70% !important;
  border-radius: 50px !important;
  margin: auto;
  text-align: center !important;
}

.pin_box {
  width: 100%;
  padding-top: 12px !important;
}

.error_pin {
  text-align: center;
  color: #f05d2e !important;
  font-size: 12px !important;
}

.ask_buttons {
  display: flex;
  gap: 24px;
  margin-top: 24px;
}

.ask_button {
  width: 120px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f05d2e;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  user-select: none;
  /* transition: all .1s ease; */
}

.ask_button1:active {
  opacity: 0.2;
}

.ask_button:active {
  opacity: 0.2;
}

.ask_button1 {
  width: 120px;
  height: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #264740;
  color: #fff;
  border-radius: 20px;
  font-size: 14px;
  user-select: none;
  /* transition: all .1s ease; */
}

.join_name {
  width: 80%;
  border: 1px solid #607d8b;
  border-radius: 22px;
  margin-top: 12px;
}
</style>
